export const PDI = {
	flockTrailer: [{
		v1: [
			{
				category: "Overview",
				description: "Enter information about the unit.",
				sections: [
					{
						name: "Unit Overview",
						description: null,
						items: [
							{
								name: "Unit Identifiers",
								slug: "unit_identifiers",
								stations: [0],
								description: ["Overview of the unit."],
								hideCheckbox: true,
								form: [
									{
										label: "Unit VIN",
										type: "tel",
										id: "VIN",
										placeholder: "Enter VIN Number",
										maxLength: 17,
										pattern: "^[A-HJ-NPR-Z0-9]{11,17}$",
										description: "Vehicle Identification Number (11-17 chars).",
										overrideComponent: "vin"

									},
									{
										label: "Unit Identifier (name)",
										type: "text",
										id: "unit_identifiers_unit_identifier_name",
										placeholder: "e.g. Flock Trailer 251234566",
										description: `Human-readable or &quot;speakable&quot; identifier for the unit (asset name or label).`
									},
									{
										label: "Unit Model",
										type: "text",
										id: "unit_identifiers_unit_model",
										placeholder: "Enter unit model",
										defaultValue: "Flock Trailer",
										description: "Official model name or number printed on the unit/plate."
									},
									{
										label: "Unit Version",
										type: "text",
										id: "unit_identifiers_make_unit_version",
										placeholder: "Enter make/unit version",
										defaultValue: "1.0.0",
										description: "Manufacturer version of hardware/firmware/components."
									},
									{
										label: "Unit Year",
										type: "number",
										id: "unit_identifiers_unit_year",
										placeholder: "YYYY",
										min: 1900,
										max: 2100,
										step: 1,
										defaultValue: new Date().getFullYear().toString(),
										description: "Model or manufacturing year of the unit (four digits)."
									}
								]
							}
						]
					}
				]
			},

			{
				category: "Masthead",
				description: null,
				sections: [
					{
						name: "Masthead Details",
						description: null,
						items: [

							{
								name: "QR/Barcodes stickers have been printed and places",
								slug: "masthead_qr_barcodes_stickers_have_been_printed_and_places",
								stations: [1],
								description: ["All QR/Barcodes stickers have been added to the inside of the Masthead Door", "&bull; Talkdown POE Speakdown", "&bull; Camera Trailer PTZ (100)", "&bull; Camera Trailer PTZ (101)", "&bull; Compute Box v1.1"],
								images: ["3.png", "4.png"],
							},
							{
								name: "Cameras (Masthead)",
								slug: "cameras",
								stations: [9],
								description: [
									"Enter details for the cameras installed on the masthead.",
									"• Camera 1 = Position` 1 (PTZ), right of the masthead door.",
									"• Camera 2 = Position 2 (Multisensor), opposite side of the masthead door.",
									"• Camera 3 = Position 3 (PTZ), left of the masthead door."
								],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Camera 1 Make",
										type: "text",
										id: "cameras_camera_1_make",
										placeholder: "Enter make of Camera 1",
										description: "Make for Camera 1.",
										defaultValue: "Uniview"
									},
									{
										label: "Camera 1 Model",
										type: "text",
										id: "cameras_camera_1_model",
										placeholder: "Enter model of Camera 1",
										description: "Model for Camera 1.",
										defaultValue: "PTZ 100 (704-00032)"
									},
									{
										label: "Camera 1 Serial Number",
										type: "text",
										id: "cameras_camera_1_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number for Camera 1."
									},
									{
										label: "Camera 2 Make",
										type: "text",
										id: "cameras_camera_2_make",
										placeholder: "Enter make of Camera 2",
										description: "Make for Camera 2.",
										defaultValue: "Axis"
									},
									{
										label: "Camera 2 Serial Number",
										type: "text",
										id: "cameras_camera_2_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number for Camera 2."
									},
									{
										label: "Camera 3 Make",
										type: "text",
										id: "cameras_camera_3_make",
										placeholder: "Enter make of Camera 3",
										description: "Make for Camera 3.",
										defaultValue: "Uniview"
									},
									{
										label: "Camera 3 Model",
										type: "text",
										id: "cameras_camera_3_model",
										placeholder: "Enter model of Camera 3",
										description: "Model for Camera 3.",
										defaultValue: "PTZ 101 (704-00033)"
									},
									{
										label: "Camera 3 Serial Number",
										type: "text",
										id: "cameras_camera_3_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number for Camera 3."
									}
								]
							},

							{
								name: "Speaker Serial Number",
								slug: "speaker_serial_number",
								stations: [1],
								description: ["Serial  for the masthead speaker."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Speaker Make",
										type: "text",
										id: "speakers_make",
										placeholder: "Enter make of Speaker",
										description: "Make for Speaker.",
										defaultValue: "Axis"
									},
									{
										label: "Speaker Model",
										type: "text",
										id: "speakers_model",
										placeholder: "Enter model of Speaker",
										description: "Model for Speaker.",
										defaultValue: "PoE Speaker (704-00031)"
									},
									{
										label: "Speaker Serial Number",
										type: "text",
										id: "speaker_serial_number_speaker_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the speaker device."
									}
								]
							},

							{
								name: "Compute Box",
								slug: "compute_box",
								stations: [1],
								description: ["Enter details about the Compute Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Compute Box Make",
										type: "text",
										id: "compute_box_compute_box_make",
										placeholder: "Enter Maker",
										description: "Maker of the Compute Box",
										defaultValue: "Flock"
									},
									{
										label: "Compute Box Model",
										type: "text",
										id: "compute_box_compute_box_model",
										placeholder: "Enter Model",
										description: "Model of the Compute Box",
										defaultValue: "705-00010"
									},
									{
										label: "Compute Box Version",
										type: "text",
										id: "compute_box_compute_box_version",
										placeholder: "Enter Version",
										description: "Version assigned to the Compute Box.",
										defaultValue: "1.1.0"
									},
									{
										label: "Date Created of Compute Box",
										type: "text",
										id: "compute_box_compute_box_date_created",
										placeholder: "Enter Date Created",
										description: "Date when the Compute Box was created.",
										defaultValue: (new Date()).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
									},
									{
										label: "Compute Box Serial Number",
										type: "text",
										id: "compute_box_compute_box_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number assigned to the Compute Box."
									}
								]
							},

							{
								name: "PoE Switch",
								slug: "poe_switch",
								stations: [1],
								description: ["Manufacturer/brand and serial for the PoE switch."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "PoE Switch Make",
										type: "text",
										id: "poe_switch_poe_switch_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the PoE switch.",
										defaultValue: "Linovision"
									},
									{
										label: "PoE Switch Model",
										type: "text",
										id: "poe_switch_poe_switch_model",
										placeholder: "Enter model",
										description: "Model of the PoE switch.",
										defaultValue: "8-Port (POE-SW508G2)"
									},
									{
										label: "PoE Switch Serial Number",
										type: "text",
										id: "poe_switch_poe_switch_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the PoE switch."
									}
								]
							}
						]
					},
					{
						name: "Housing",
						description: null,
						items: [
							{
								name: "Housing and mounts are free of defects",
								slug: "masthead_housing_housing_and_mounts_are_free_of_defects",
								stations: [2],
								description: ["Free of scratches, dents, or paint imperfections"],
								images: ["masthead_housing_housing_and_mounts_are_free_of_defects.png"]
							},
							{
								name: "The lock is the appropriate keylock",
								slug: "masthead_housing_the_lock_is_the_appropriate_keylock",
								stations: [1],
								description: ["Should be 751 key and can lock/unlock"],
								images: null
							},
							{
								name: "Seal for door has been added",
								slug: "masthead_housing_seal_for_door_has_been_added",
								stations: [1],
								description: ["The waterproof seal properly seals"],
								images: null
							},
							{
								name: "Door shuts properly",
								slug: "masthead_housing_door_shuts_properly",
								stations: [1],
								description: ["The door opens, closes and locks"],
								images: null
							},
							{
								name: "Correct voltage is available",
								slug: "masthead_housing_correct_voltage_is_available",
								stations: [1],
								description: ["Using a multimeter, identify the correct voltage per pin (12v, 20v, and one 48v)", "&bull; Pin 1 = 48v", "&bull; Pin 2 = 20v", "&bull; Pin 3 = 12v", "&bull; Pin 4, 5, 6 = Ground"],
								images: ["masthead_housing_correct_voltage_is_available.png"]
							},
							{
								name: "Cable Glands have been installed",
								slug: "masthead_housing_cable_glands_have_been_installed",
								stations: [1],
								description: ["All glands should be the same (black) and properly sealing cords"],
								images: ["masthead_housing_cable_glands_have_been_installed.png"]
							},
							{
								name: "Beacon is attached on the Position 2 Mount",
								slug: "masthead_housing_beacon_is_attached_on_the_position_2_mount",
								stations: [1],
								description: ["The wires are hidden within the mount and properly connected"],
								images: ["13.png"]
							},
							{
								name: "Power and ethernet added to Compute Box",
								slug: "masthead_housing_power_and_ethernet_added_to_compute_box",
								stations: [1],
								description: ["IP67 cords are connected into their appropriate position in the Compute Box", "&bull; Power cord is connected to the left side of the Compute Box", "&bull; Ethernet cord is connected to the right side of the Compute Box", "&bull; Cords are properly sealed with the cable glands", "&bull; Both cords are even length showing, reference image."],
								images: ["masthead_housing_power_and_ethernet_added_to_compute_box.png"]
							},
							{
								name: "Relay 1 turns on/off Beacon",
								slug: "masthead_housing_relay_1_turns_on_off_beacon",
								stations: [1],
								description: ["Using Cerbo GX"],
								images: null
							},
							{
								name: "12v Breaker turns on/off Beacon",
								slug: "masthead_housing_12v_breaker_turns_on_off_beacon",
								stations: [1],
								description: ["Using Power Box breaker, identified as &quot;Strobe&quot; toggle the switch on/off", "<b class='tw-font-bold'>NOTE:</b> The &quot;Strobe&quot; breaker will only work if &quot;System&quot; breaker is on and the digital relay in Cerbo GX (or in VRM) is set to ON"],
								images: null
							},
							{
								name: "Seal has been added for mounts",
								slug: "masthead_housing_seal_has_been_added_for_mounts",
								stations: [1],
								description: ["Proper seal has been applied to each mount, identified as &quot;Strobe&quot; toggle the switch on/off"],
								images: null
							},
							{
								name: "The two (2) Uniview Cameras are mounted in correct position",
								slug: "masthead_housing_the_two_2_uniview_cameras_are_mounted_in_correct_position",
								stations: [1],
								description: ["Identify the correct Uniview Cameras for Position 1 and Position 3"],
								images: ["12.png"]
							},
							{
								name: "The two (2) Uniview Cameras and one (1) Axis camera are connected to PoE",
								slug: "masthead_housing_the_two_2_uniview_cameras_and_one_1_axis_camera_are_connected_to_poe",
								stations: [1],
								description: ["Identify the green/orange lights (status lights on PoE Switch)"],
								images: ["11.png"]
							},
							{
								name: "All three (3) mounts are properly mounted",
								slug: "masthead_housing_all_three_3_mounts_are_properly_mounted",
								stations: [1],
								description: ["There should be four (4) bolts per mount and each have seal"],
								images: null
							},
							{
								name: "PoE Operating Properly",
								slug: "masthead_housing_poe_operating_properly",
								stations: [1],
								description: ["PoE Switch is receiving 48v"],
								images: ["11.png"]
							},
							{
								name: "The Compute Box is receiving power",
								slug: "masthead_housing_the_compute_box_is_receiving_power",
								stations: [1],
								description: ["Identify color of the light on the Compute Box"],
								images: null
							},
							{
								name: "Gusset Plates have been installed and secured",
								slug: "masthead_gusset",
								stations: [1],
								description: ["The additional support for camera mounts are installed and secured with bolts and rubber washers."],
								images: ["gusset.png"]
							}
						]
					}
				]
			},

			{
				category: "Boxes",
				description: null,
				sections: [
					{
						name: "Power Box Details",
						description: null,
						slug: "power_box_details",
						items: [
							{
								name: "Add Securing Adhesive Sealant",
								slug: "add_securing_adhesive_sealant",
								stations: [1],
								description: ["Silicone RTV (80050)", "&bull; Battery Monitor", "&bull; GPS USB", "&bull; Cerbo GX (3 VE-Direct)"],
								images: null
							}, {
								name: "Battery Disconnect",
								slug: "battery_disconnect_angle",
								stations: [1],
								description: ["The battery disconnect 'ON' is facing up."],
								images: null
							},
							{
								name: "QR/Barcodes stickers have been printed and places",
								slug: "power_box_qr_barcodes_stickers_have_been_printed_and_places",
								stations: [1],
								description: ["All QR/Barcodes stickers have been added to the top/left of the inside lid of the Power Box", "&bull; Talkdown POE Speakdown", "&bull; Camera Trailer PTZ (100)", "&bull; Camera Trailer PTZ (101)", "&bull; Compute Box v1.1", "&bull; VWZ BackHaul Box (only in power box)"],
								images: null,
							},
							{
								name: "Name is updated in VRM",
								slug: "power_box_name_is_updated_in_vrm",
								stations: [1],
								description: ["The name has been updated in the Victron Remote Management (VRM) portal.", "&bull; Name should be 'Flex Security - Flock Trailer ' + 'Two Digit of Year' + 'Unit Number' (last 6 digits of the VIN) + ' - ' + Serial Number of Panel (from Future Sales) + ' - ' + 'VIN'", "&bull; Example: 'Flex Security - Flock Trailer 25123456 - 25FFP0006 - 1FTFW1E50PKA12345'", "&bull; Settings > 'Name of your installation'"],
								images: null,
							},
							{
								name: "Victron Details",
								slug: "victron",
								stations: [1],
								description: ["Details about Victron components.", "Make sure all components are showing in the VRM portal:", "&bull; Go to <b>Advanced</b> &gt; Widgets (top right icon) &gt; Click on each and <b>'Enable All'</b> "],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "VRM Link",
										type: "url",
										id: "victron_vrm_link",
										placeholder: "https://vrm.victronenergy.com/...",
										description: "Direct URL to the unit in Victron VRM."
									},
									{
										label: "'Victron Cerbo GX' Serial Number",
										type: "text",
										id: "victron_victron_cerbo_gx_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Cerbo GX."
									},
									{
										label: "'SmartSolar Charge Controller MPPT 150A' Serial Number",
										type: "text",
										id: "victron_charge_controller_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartSolar Charge Controller."
									},
									{
										label: "'Orion-Tr 12v|24v - 10A' Serial Number",
										type: "text",
										id: "victron_orion_tr_12v_24v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr 12v|24v."
									},
									{
										label: "'Orion-Tr Smart 12v|48v - 8A' Serial Number",
										type: "text",
										id: "victron_orion_tr_smart_12v_48v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr Smart 12v|48v."
									},
									{
										label: "'SmartCharger 12v|50A'. Serial Number",
										type: "text",
										id: "victron_smartcharger_12v_50a_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartCharger 12v|50A."
									},
									{
										label: "Victron Battery Monitor Serial Number",
										type: "text",
										id: "victron_victron_battery_monitor_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Battery Monitor."
									}
								]
							},

							{
								name: "All Components Added to VRM",
								slug: "vrm_components_all_added",
								stations: [1],
								description: ["All Victron components have been added to the VRM portal.", "&bull; Gateway (Cerbo GX)", "&bull; Battery Monitor", "&bull; Solar Charger", "&bull; System", "&bull; Two (2) Temperature Sensors (Plate, Battery)", "&bull; DC-DC 12v-48v Converter (48v)", "&bull; DC-DC 12v-20v Converter (20v)", "&bull; Strobe", "&bull; Weather", "&bull; GPS/Location"],
								images: ["vrm_components_0.png", "vrm_components_1.png"]
							},

							{
								name: "BMV Settings Updated",
								slug: "vrm_component_bmv_settings_updated",
								stations: [1],
								description: ["Update BMV-712 Display Settings.", "The delta is turning on 'Power display' and 'State-of-charge display'"],
								images: ["bmv.jpg"]
							},

							{
								name: "Modem (Power Box)",
								slug: "modem_power_box",
								stations: [1],
								description: ["The cellular modem located in the Power Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Modem (Power Box) Make",
										type: "text",
										id: "modem_power_box_modem_power_box_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the Power Box modem.",
										defaultValue: "Sierra Wireless"
									},
									{
										label: "Modem (Power Box) Model",
										type: "text",
										id: "modem_power_box_modem_power_box_model",
										placeholder: "Enter model",
										description: "Model name or number of the Power Box modem.",
										defaultValue: "6001124"
									},
									{
										label: "Modem (Power Box) Serial Number",
										type: "text",
										id: "modem_power_box_modem_power_box_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the Power Box modem."
									},
									{
										label: "Modem (Power Box) IMEI",
										type: "text",
										id: "modem_power_box_modem_power_box_imei",
										placeholder: "Enter IMEI",
										pattern: "^\\d{15}$",
										inputMode: "numeric",
										description: "IMEI of the modem (15 digits, numbers only)."
									}
								]
							},
						]
					},
					{
						name: "Power Box",
						description: null,
						items: [
							{
								name: "Solar Panel Wiring terminated and connected",
								slug: "boxes_power_box_solar_panel_wiring_terminated_and_connected",
								stations: [1],
								description: ['All wiring is connected and secured.', 'Confirm that the solar panel wiring is connected to the correct terminals on the charge controller.'],
								images: null
							},
							{
								name: "Battery terminals have been torqued to spec",
								slug: "boxes_power_box_battery_terminals_have_been_torqued_to_spec",
								stations: [1],
								description: ["100in lbs"],
								images: null
							},
							{
								name: "All labels/identifiers have been added to wires and breakers",
								slug: "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers",
								stations: [1],
								description: ["PV, 12v, 20v, 48v, Strobe, System"],
								images: ["boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers1.png", "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers2.png"]
							},
							{
								name: "Control Box Installed and wiring routed correctly and secured",
								slug: "boxes_power_box_control_box_installed_and_wiring_routed_correctly_and_secured",
								stations: [1],
								description: ["Check for looseness or play by moving the component"],
								images: null
							},
							{
								name: "Correct voltage is available",
								slug: "boxes_power_box_correct_voltage_is_available",
								stations: [1],
								description: [
									"Using a multimeter, identify the one (1) 20v, one (1) 20v and one (1) 48v for breakers.",
									"Check all converters for their input (12v) and output (24V/2)V/48v)"
								],
								images: ["18.png"]
							},
							{
								name: "48v Breaker turns on/off PoE Switch in Masthead",
								slug: "boxes_power_box_48v_breaker_turns_on_off_poe_switch_in_masthead",
								stations: [1],
								description: [],
								images: ["boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers1.png", "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers2.png"]
							},
							{
								name: "20v Breaker turns on/off Beacon in Masthead and two (2) Strobes on the trailer",
								slug: "boxes_power_box_24v_breaker_turns_on_off_beacon_in_masthead_and_two_2_strobes_on_the_trailer",
								stations: [1],
								description: [],
								images: ["boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers1.png", "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers2.png"]
							},
							{
								name: "Relay 1 turns on/off Beacon in Masthead",
								slug: "boxes_power_box_relay_1_turns_on_off_beacon_in_masthead",
								stations: [1],
								description: [],
								images: ["boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers1.png", "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers2.png"]
							},
							{
								name: "Relay 2 turns on/off PoE Switch in Masthead",
								slug: "boxes_power_box_relay_2_turns_on_off_poe_switch_in_masthead",
								stations: [1],
								description: [],
								images: ["boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers1.png", "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers2.png"]
							},
							{
								name: "Cerbo GX status reflects correct state for Relay 1",
								slug: "boxes_power_box_cerbo_gx_status_reflects_correct_state_for_relay_1",
								stations: [1],
								description: ["Status shows ON/OFF correctly"],
								images: null
							},
							{
								name: "Cerbo GX status reflects correct state for Relay 2",
								slug: "boxes_power_box_cerbo_gx_status_reflects_correct_state_for_relay_2",
								stations: [1],
								description: ["Status shows ON/OFF correctly"],
								images: null
							},
							{
								name: "Charge controller breakers operate correctly",
								slug: "boxes_power_box_charge_controller_breakers_operate_correctly",
								stations: [1],
								description: ["Switch the 50A charge controller ON and OFF"],
								images: ["boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers1.png", "boxes_power_box_all_labels_identifiers_have_been_added_to_wires_and_breakers2.png"]
							},
							{
								name: "Components wiring hooked up correctly",
								slug: "boxes_power_box_components_wiring_hooked_up_correctly",
								stations: [1],
								description: ["Battery cables, conduit wires correctly hooked up"],
								images: null
							},
							{
								name: "Power disconnect turns on/off all components",
								slug: "boxes_power_box_power_disconnect_turns_on_off_all_components",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Battery monitor displays correct voltage of the batteries",
								slug: "boxes_power_box_battery_monitor_displays_correct_voltage_of_the_batteries",
								stations: [1],
								description: ["The Mopeka's have been calibrated and connected to the unit's Cerbo GX", "Confirm voltage matches the Cerbo GX and VRM"],
								images: null
							},
							{
								name: "Shore power input works properly",
								slug: "boxes_power_box_shore_power_input_works_properly",
								stations: [1],
								description: ["Confirm status change in Cerbo GX"],
								images: null
							},
							{
								name: "Solar breaker functions properly",
								slug: "boxes_power_box_solar_breaker_functions_properly",
								stations: [1],
								description: ["Switches the solar panels ON and OFF"],
								images: null
							},
							{
								name: "Securement of Victron wires (VE-Direct)",
								slug: "boxes_power_box_securement_of_victron_wires_ve_direct",
								stations: [1],
								description: ["All wires are secured into the Cerbo GX"],
								images: null
							},
							{
								name: "Modem has power",
								slug: "boxes_power_box_modem_has_power",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "GPS puck location",
								slug: "boxes_power_box_gps_puck_location",
								stations: [1],
								description: ["GPS puck place on the top lid of outside the box"],
								images: null
							},
							{
								name: "Modem connections",
								slug: "boxes_power_box_modem_connections",
								stations: [1],
								description: ["Connected to antenna, GPS and ethernet cable to Cerbo GX"],
								images: null
							},
							{
								name: "Power panel finish",
								slug: "boxes_power_box_power_panel_finish",
								stations: [1],
								description: ["Power panel has wrap around edges"],
								images: null
							},
							{
								name: "Victron firmware updated",
								slug: "boxes_power_box_victron_firmware_updated",
								stations: [1],
								description: ["Victron components updated to the latest or specified firmware"],
								images: null
							},
							{
								name: "Timestamps updated",
								slug: "boxes_power_box_timestamps_updated",
								stations: [1],
								description: ["Timestamps are updated in Cerbo GX", "&bull; Should be set to Eastern Time Zone (ET)"],
								images: null
							},
							{
								name: "Victron units registered and visible in VRM",
								slug: "boxes_power_box_victron_units_registered_and_visible_in_vrm",
								stations: [1],
								description: ["VRM shows realtime for all components"],
								images: null
							},
							{
								name: "Battery shunt set to correct Amp Hours",
								slug: "boxes_power_box_battery_shunt_set_to_correct_amp_hours",
								stations: [1],
								description: ["Set to 800Ah"],
								images: null
							},
							{
								name: "Modem mounting",
								slug: "boxes_power_box_modem_mounting",
								stations: [1],
								description: ["Located on the front side of the Power Panel"],
								images: null
							},
							{
								name: "Modem connection to provider",
								slug: "boxes_power_box_modem_connection_to_provider",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Strut functionality",
								slug: "boxes_power_box_strut_functionality",
								stations: [1],
								description: ["Strut works properly"],
								images: ["19.png"]
							},
							{
								name: "Graphics installed properly",
								slug: "boxes_power_box_graphics_installed_properly",
								stations: [1],
								description: ["No bubbles, no misprints"],
								images: ["20.png"]
							},
							{
								name: "Box free of defects",
								slug: "boxes_power_box_box_free_of_defects",
								stations: [1],
								description: ["Free of scratches, dents, or paint imperfections"],
								images: ["21.png"]
							},
							{
								name: "Lock key specification",
								slug: "boxes_power_box_lock_key_specification",
								stations: [1],
								description: ["Should be X key and can lock/unlock", "Identify the lock type in Details"],
								images: ["22.png", "23.png"]
							},
							{
								name: "Vent/holes verification",
								slug: "boxes_power_box_vent_holes_verification",
								stations: [1],
								description: ["Box has no vents and appropriate holes"],
								images: null
							},
							{
								name: "VRM user access",
								slug: "boxes_power_box_vrm_user_access",
								stations: [1],
								description: ["Appropriate users have access to VRM"],
								images: null
							},
							{
								name: "VRM has been transferred to Customer's Account",
								slug: "boxes_power_box_vrm_has_been_transferred_to_customers_account",
								stations: [1],
								description: ["VRM is now accessible from the Customer's Account"],
								images: null
							}, {
								name: "Temperature sensor connected and working properly",
								slug: "boxes_power_box_temperature_sensor_connected_and_working_properly",
								stations: [1],
								description: ["The two (2) Temperature sensors are connected to Cerbo GX and shows correct temperature", "&bull; One (1) sensor is placed on the Battery Box", "&bull; One (1) sensor is placed on the Power Box"],
								images: null
							}, {
								name: "Updates to PINs and Bluetooth functionality",
								slug: "boxes_power_box_bluetooth_functionality_has_been_disabled_on_victron_components1",
								stations: [1],
								description: ["&bull; <i>Cerbo GX MK2</i> - Set PIN to <b>035625</b>, then disable Bluetooth", "&bull; <i>BMV-712 Smart</i> - Set PIN to <b>035625</b>, then disable Bluetooth", "&bull; <i>SmartSolar Charger MPPT 150/60./9</i> - Set PIN to <b>035625</b>, then disable Bluetooth", "&bull; <i>Phoenix Smart IP43 Charger 12|50</i> - Set PIN to <b>035625</b>, then disable Bluetooth", "&bull; <i>Orion-Tr Smart DC-DC Charger Isolated 12|24</i> - Keep Bluetooth enabled, set PIN to <b>035625</b> first, then update Bluetooth to show for only 30 seconds", "&bull; <i>Orion-Tr Smart DC-DC Charger Isolated 12|48</i> - Keep Bluetooth enabled, set PIN to <b>035625</b> first, then update Bluetooth to show for only 30 seconds"],
								images: null
							}, {
								name: "Bluetooth functionality has been disabled for specific Victron components",
								slug: "boxes_power_box_bluetooth_functionality_has_been_disabled_on_victron_components",
								stations: [1],
								description: ["Bluetooth has been disabled on Victron components that are not DC/DC converters.", "&bull; Cerbo GX", "&bull; SmartSolar", "&bull; SmartCharger (must have shore power plugged in)", "&bull; Battery Monitor", "<b>NOTE:</b> Do not disable DC-DC Converters for 12 to 24 and 12 to 48."],
								images: null
							}, {
								name: "Bluetooth PIN has been updated for all components",
								slug: "boxes_power_box_bluetooth_functionality_has_been_disabled_on_victron_components2",
								stations: [1],
								description: ["Update the PIN for all Victron components", "&bull; <i>Orion-Tr Smart DC-DC Charger Isolated 12|24</i> should be <b>35625</b>", "&bull; <i>Orion-Tr Smart DC-DC Charger Isolated 12|48</i> should be <b>35625</b>"],
								images: null
							}
						]
					},
					{
						name: "Battery Box",
						description: null,
						items: [
							{
								name: "Battery cables and wires correctly hooked up",
								slug: "boxes_battery_box_battery_cables_and_wires_correctly_hooked_up",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Battery tray installed and secured",
								slug: "boxes_battery_box_battery_tray_installed_and_secured",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Battery cables landed and torqued",
								slug: "boxes_battery_box_battery_cables_landed_and_torqued",
								stations: [1],
								description: ["Torqued to specified TQ 100in lbs."],
								images: null
							},
							{
								name: "Batteries are fully charged",
								slug: "boxes_battery_box_batteries_are_fully_charged",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Battery disconnect",
								slug: "boxes_battery_box_battery_disconnect",
								stations: [1],
								description: ["Toggles on/off and disconnects power from the unit"],
								images: null
							},
							{
								name: "Strut works properly",
								slug: "boxes_battery_box_strut_works_properly",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Graphics installed properly",
								slug: "boxes_battery_box_graphics_installed_properly",
								stations: [1],
								description: ["No bubbles, no misprints"],
								images: ["24.png"]
							},
							{
								name: "Box free of defects",
								slug: "boxes_battery_box_box_free_of_defects",
								stations: [1],
								description: ["Free of scratches, dents, or paint imperfections"],
								images: ["25.png"]
							},
							{
								name: "Lock key specification",
								slug: "boxes_battery_box_lock_key_specification",
								stations: [1],
								description: ["Should be X key and can lock/unlock"],
								images: ["22.png", "23.png"]
							},
							{
								name: "Vent/holes verification",
								slug: "boxes_battery_box_vent_holes_verification",
								stations: [1],
								description: ["Box has no vents and appropriate holes"],
								images: null
							},
							{
								name: "Lithium Battery Warning Label applied",
								slug: "boxes_battery_box_lithium_warning",
								stations: [1],
								description: ["Lithium Battery Warning Label is applied on the outside of the box"],
								images: ["boxes_battery_box_lithium_warning.png"]
							}
						]
					},
					{
						name: "Storage Box 1 (Near Power Box)",
						description: null,
						items: [
							{
								name: "Graphics installed properly",
								slug: "boxes_storage_box_1_near_power_box_graphics_installed_properly",
								stations: [1],
								description: ["No bubbles, no misprints"],
								images: ["26.png"]
							},
							{
								name: "“Call 911” Graphic placed appropriately",
								slug: "boxes_storage_box_1_near_power_box_call_911_graphic_placed_appropriately",
								stations: [1],
								description: [],
								images: ["63.png", "labels_warning_labels_call_911_1.png", "labels_warning_labels_call_911_2.png"]
							},
							{
								name: "Box free of defects",
								slug: "boxes_storage_box_1_near_power_box_box_free_of_defects",
								stations: [1],
								description: ["Free of scratches, dents, or paint imperfections"],
								images: ["26.png"]
							},
							{
								name: "Strut works properly",
								slug: "boxes_storage_box_1_near_power_box_strut_works_properly",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Lock key specification",
								slug: "boxes_storage_box_1_near_power_box_lock_key_specification",
								stations: [1],
								description: ["Should be X key and can lock/unlock"],
								images: ["22.png", "23.png"]
							},
							{
								name: "Vent/holes verification",
								slug: "boxes_storage_box_1_near_power_box_vent_holes_verification",
								stations: [1],
								description: ["Box has no vents and appropriate holes"],
								images: ["27.png", "28.png"]
							}, {
								name: "Jack Locks are stored inside the box",
								slug: "boxes_storage_box_1_near_power_box_jack_locks_are_stored_inside_the_box",
								stations: [1],
								description: ["All four (4) jack locks are stored inside the box"],
								images: null
							}
						]
					},
					{
						name: "Storage Box 2 (Near Battery Box)",
						description: null,
						items: [
							{
								name: "Graphics installed properly",
								slug: "boxes_storage_box_2_near_battery_box_graphics_installed_properly",
								stations: [1],
								description: ["No bubbles, no misprints"],
								images: ["31.png"]
							},
							{
								name: "“Call 911” Graphic placed appropriately",
								slug: "boxes_storage_box_2_near_battery_box_call_911_graphic_placed_appropriately",
								stations: [1],
								description: [],
								images: ["63.png", "labels_warning_labels_call_911_1.png", "labels_warning_labels_call_911_2.png"]
							},
							{
								name: "Strut works properly",
								slug: "boxes_storage_box_2_near_battery_box_strut_works_properly",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Box free of defects",
								slug: "boxes_storage_box_2_near_battery_box_box_free_of_defects",
								stations: [1],
								description: ["Free of scratches, dents, or paint imperfections"],
								images: ["32.png"]
							},
							{
								name: "Lock key specification",
								slug: "boxes_storage_box_2_near_battery_box_lock_key_specification",
								stations: [1],
								description: ["Should be X key and can lock/unlock"],
								images: ["22.png", "23.png"]
							},
							{
								name: "Vent/holes verification",
								slug: "boxes_storage_box_2_near_battery_box_vent_holes_verification",
								stations: [1],
								description: ["Box has no vents and appropriate holes"],
								images: ["27.png", "28.png"]
							}
						]
					}
				]
			},

			{
				category: "Frame",
				description: null,
				sections: [
					{
						name: "Accessibility",
						description: null,
						items: [
							{
								name: "Two (2) keys for all four (4) boxes",
								slug: "frame_accessibility_two_2_keys_for_all_four_4_boxes",
								stations: [1],
								description: ["Keys and locks are 545"],
								images: ["33.png"]
							},
							{
								name: "Two (2) keys for the Masthead (and Generator Box)",
								slug: "frame_accessibility_two_2_keys_for_the_masthead_and_gen_box",
								stations: [1],
								description: ["Keys and lock are 751"],
								images: null
							}
						]
					},
					{
						name: "Camera Mast Performance",
						description: null,
						items: [
							{
								name: "Mast extends and retracts",
								slug: "frame_camera_mast_performance_mast_extends_and_retracts",
								stations: [1],
								description: ["Fully functional: extends and retracts using hand crank or drill"],
								images: null
							},
							{
								name: "Winch securement",
								slug: "frame_camera_mast_performance_winch_securement",
								stations: [1],
								description: ["Winch is securely welded to the mast"],
								images: ["34.png", "35.png"]
							},
							{
								name: "Cable cord condition and tension",
								slug: "frame_camera_mast_performance_cable_cord_condition_and_tension",
								stations: [1],
								description: ["Cable cord is free of any defects with proper tension"],
								images: null
							},
							{
								name: "Pucks installation",
								slug: "frame_camera_mast_performance_pucks_installation",
								stations: [1],
								description: ["All pucks are installed and appropriately supporting the internal pieces"],
								images: ["36.png"]
							},
							{
								name: "Wormwheel condition",
								slug: "frame_camera_mast_performance_wormwheel_condition",
								stations: [1],
								description: ["Wormwheel is free of defects in the winch"],
								images: null
							},
							{
								name: "Wormwheel greased",
								slug: "frame_camera_mast_performance_wormwheel_greased",
								stations: [1],
								description: ["Wormwheel has been greased"],
								images: ["37.png"]
							},
							{
								name: "Pucks greased",
								slug: "frame_camera_mast_performance_pucks_greased",
								stations: [1],
								description: ["Pucks have been greased"],
								images: null
							},
							{
								name: "Mast cycles exercised",
								slug: "frame_camera_mast_performance_mast_cycles_exercised",
								stations: [1],
								description: ["Mast has been extended and retracted", "Exercise 10 full reps"],
								images: null
							},
							{
								name: "Graphics installed properly",
								slug: "frame_camera_mast_performance_graphics_installed_properly",
								stations: [1],
								description: ["No bubbles, no misprints"],
								images: null
							},
							{
								name: "Mast free of defects",
								slug: "frame_camera_mast_performance_mast_free_of_defects",
								stations: [1],
								description: ["Free of scratches, dents, or paint imperfections"],
								images: ["39.png"]
							}
						]
					},
					{
						name: "Chassis",
						description: null,
						items: [
							{
								name: "Levels installed",
								slug: "frame_chassis_levels_installed",
								stations: [1],
								description: ["Levels installed on front and left side of chassis"],
								images: ["40.png", "41.png"]
							},
							{
								name: "Strobes installed",
								slug: "frame_chassis_strobes_installed",
								stations: [1],
								description: ["Verify two (2) strobes are properly installed"],
								images: ["42.png"]
							},
							{
								name: "Strobes working",
								slug: "frame_chassis_strobes_working",
								stations: [1],
								description: ["Verify two (2) strobes are properly working"],
								images: ["44.png"]
							},
							{
								name: "Stabilizing jacks operation",
								slug: "frame_chassis_stabilizing_jacks_operation",
								stations: [1],
								description: [
									"The four (4) stabilizing jacks rotate and go up/down",
									"Exercise each jack 5 times up/down"
								],
								images: null
							},
							{
								name: "Stabilizing jacks condition",
								slug: "frame_chassis_stabilizing_jacks_condition",
								stations: [1],
								description: ["The four (4) stabilizing jacks are free of defects"],
								images: ["45.png"]
							},
							{
								name: "Locking pins operation",
								slug: "frame_chassis_locking_pins_operation",
								stations: [1],
								description: [
									"The four (4) lock pins legs extend and locking pins lock",
									"Exercise the four (4) locking pins 10 times"
								],
								images: ["46.png"]
							},
							{
								name: "Tongue jack operation",
								slug: "frame_chassis_tongue_jack_operation",
								stations: [1],
								description: [
									"Tongue jack goes up/down",
									"Exercise jacks 5 times up/down"
								],
								images: ["47.png"]
							},
							{
								name: "Tongue jack swivel and lock",
								slug: "frame_chassis_tongue_jack_swivel_and_lock",
								stations: [1],
								description: ["Tongue jack swivels and locks in place"],
								images: ["47.png", "48.png"]
							},
							{
								name: "Tongue jack condition",
								slug: "frame_chassis_tongue_jack_condition",
								stations: [1],
								description: ["Tongue jack is free of defects"],
								images: ["47.png"]
							},
							{
								name: "Wheel lugs torque",
								slug: "frame_chassis_wheel_lugs_torque",
								stations: [1],
								description: ["80lb. spec with torque wrench"],
								images: ["49.png"]
							},
							{
								name: "Wheels, axle and fenders condition",
								slug: "frame_chassis_wheels_axle_and_fenders_condition",
								stations: [1],
								description: ["Free of defects"],
								images: ["50.png", "51.png"]
							},
							{
								name: "Camera Mast & Solar Mast hardware",
								slug: "frame_chassis_camera_mast_solar_mast_hardware",
								stations: [1],
								description: ["Correct bolts installed properly", "Correct washers and seals"],
								images: ["52.png", "53.png"]
							},
							{
								name: "Cord reel cover",
								slug: "frame_chassis_cord_reel_cover",
								stations: [1],
								description: ["Cord reel cover has been installed", "Coiled cord is not visible"],
								images: ["54.png"]
							},
							{
								name: "Step-tread install",
								slug: "frame_chassis_step_tread_install",
								stations: [1],
								description: ["Step-tread in rear bumper (2 pcs.) and spine (2 pcs.) are properly installed"],
								images: ["55.png", "56.png"]
							},
							{
								name: "Tongue chains",
								slug: "frame_chassis_tongue_chains",
								stations: [1],
								description: ["Verify chains are properly secured to the frame"],
								images: ["57.png"]
							},
							{
								name: "VIN Tag",
								slug: "frame_chassis_vin_tag",
								stations: [1],
								description: ["Securely attached to the right front of the chassis"],
								images: ["58.png"]
							}
						]
					},
					{
						name: "Solar Rack",
						description: null,
						items: [
							{
								name: "Solar rack extends/retracts and locks",
								slug: "frame_solar_rack_solar_rack_extends_retracts_and_locks",
								stations: [1],
								description: ["Extend and retract fully, ensuring locking pins are properly engaged"],
								images: null
							},
							{
								name: "Solar panels secured",
								slug: "frame_solar_rack_solar_panels_secured",
								stations: [1],
								description: ["Solar Panels secured with proper hardware"],
								images: ["59.png"]
							},
							{
								name: "Cords attachment",
								slug: "frame_solar_rack_cords_attachment",
								stations: [1],
								description: ["All cords are appropriately attached", "Check for play or looseness through slight movement of cords"],
								images: ["60.png"]
							},
							{
								name: "Solar panels condition",
								slug: "frame_solar_rack_solar_panels_condition",
								stations: [1],
								description: ["Solar Panels are free of defects"],
								images: ["61.png"]
							},
							{
								name: "Solar mast and mount condition",
								slug: "frame_solar_rack_solar_mast_and_mount_condition",
								stations: [1],
								description: ["Solar mast and mount are free of defects"],
								images: ["53.png"]
							},
							{
								name: "Solar panels motion",
								slug: "frame_solar_rack_solar_panels_motion",
								stations: [1],
								description: ["Solar panels can go up/down", "Exercise solar panels 10 times up/down"],
								images: null
							},
							{
								name: "Gas strut install",
								slug: "frame_solar_rack_gas_strut_install",
								stations: [1],
								description: ["Gas strut is safely and securely installed"],
								images: ["62.png"]
							},
							{
								name: "Gas strut condition",
								slug: "frame_solar_rack_gas_strut_condition",
								stations: [1],
								description: ["Gas strut is free of any defect"],
								images: ["62.png"]
							},
							{
								name: "Solar output in VRM",
								slug: "frame_solar_rack_solar_output_in_vrm",
								stations: [1],
								description: ["Solar Panels are displaying output within VRM"],
								images: null
							}
						]
					}
				]
			},

			{
				category: "Labels",
				description: null,
				sections: [
					{
						name: "Brand",
						description: null,
						items: [
							{
								name: "All boxes branded",
								slug: "labels_brand_all_boxes_branded",
								stations: [1],
								description: [],
								images: null
							}
						]
					},
					{
						name: "Quality",
						description: null,
						items: [
							{
								name: "No air bubbles in decals",
								slug: "labels_quality_no_air_bubbles_in_decals",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "No misprints in decals",
								slug: "labels_quality_no_misprints_in_decals",
								stations: [1],
								description: [],
								images: null
							}
						]
					},
					{
						name: "Unit Stickers",
						description: null,
						items: [
							{
								name: "Masthead Label",
								slug: "labels_unit_stickers_masthead_label",
								stations: [1],
								description: ["Masthead Label added inside the camera housing"],
								images: ["4.png"]
							},
							{
								name: "Unit Label",
								slug: "labels_unit_stickers_unit_label",
								stations: [1],
								description: ["Unit Label added to the Power Box"],
								images: ["17.png"]
							},
							{
								name: "Camera labels",
								slug: "labels_unit_stickers_camera_labels",
								stations: [1],
								description: ["Cameras have their appropriate labels added"],
								images: ["6.png", "7.png", "8.png"]
							}
						]
					},
					{
						name: "Warning Labels",
						description: null,
						items: [
							{
								name: "Do not overtighten",
								slug: "labels_warning_labels_do_not_overtighten",
								stations: [1],
								description: ["Added to the Camera Mast"],
								images: null
							},
							{
								name: "Do not stand",
								slug: "labels_warning_labels_do_not_stand",
								stations: [1],
								description: ["Two per unit", "&bull; Added on top front/right corner of Power Box", "&bull; Added on top front/left corner of Battery Box"],
								images: ["68.png", "labels_warning_labels_do_not_stand_1.png", "labels_warning_labels_do_not_stand_2.png"]
							},
							{
								name: "Call 911",
								slug: "labels_warning_labels_call_911",
								stations: [1],
								description: ["Two per unit", "&bull; Added the top left corner of Storage Boxes on right side of trailer", "&bull; Added the top right corner of Storage Boxes on left side of trailer"],
								images: ["63.png", "labels_warning_labels_call_911_1.png", "labels_warning_labels_call_911_2.png"]
							},
							{
								name: "Cord Warning",
								slug: "labels_warning_labels_cord_warning",
								stations: [1],
								description: ["One per unit", "&bull; Placed to the right of the shore power outlet on the Power Box"],
								images: ["69.png", "labels_warning_labels_cord_warning_1.png"]
							},
							{
								name: "Battery Warning",
								slug: "labels_warning_labels_battery_warning",
								stations: [1],
								description: ["One per unit", "&bull; Placed to the top/left corner of the Battery Box"],
								images: null
							},
							{
								name: "Level Warning",
								slug: "labels_warning_labels_level_warning",
								stations: [1],
								description: ["Two per unit", "&bull; Placed to the front bottom/right corner of the Power Box", "&bull; Placed to the front bottom/left corner of the Battery Box"],
								images: ["65.png"]
							},
							{
								name: "Surveillance Notice",
								slug: "labels_warning_labels_surveillance_notice",
								stations: [1],
								description: ["Two per unit", "Note: Unique per retailer or customer of Flock - Provide details on which is being used", "&bull; Placed above the accent stripes on the Battery Box", "&bull; Placed above the accent stripes on the Power Box"],
								images: ["64.png"]
							},
							{
								name: "Propane Warning",
								slug: "labels_warning_labels_propane_warning",
								stations: [1],
								description: ["One per unit", "&bull; Added the top right corner of LP Box on right side of trailer"],
								images: ["66.png"]
							}
						]
					}
				]
			},

			{
				category: "Network",
				description: null,
				sections: [
					{
						name: "Connection",
						description: null,
						items: [
							{
								name: "Unit can phone home",
								slug: "network_connection_unit_can_phone_home",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Compute Box connects to Flock",
								slug: "network_connection_compute_box_connects_to_flock",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Modem in Power Box has provider connection",
								slug: "network_connection_modem_in_power_box_has_provider_connection",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Compute Box has provider/services connection",
								slug: "network_connection_compute_box_has_provider_services_connection",
								stations: [1],
								description: [],
								images: null
							}
						]
					}
				]
			},

			{
				category: "Unit Readiness & Documentation",
				description: null,
				sections: [
					{
						name: "Documentation",
						description: null,
						items: [
							{
								name: "Unit documentation complete",
								slug: "unit_readiness_documentation_documentation_unit_documentation_complete",
								stations: [1],
								description: ["Unit has all items documented"],
								images: null
							}
						]
					},
					{
						name: "Network Quality",
						description: null,
						items: [
							{
								name: "Quality data connection",
								slug: "unit_readiness_documentation_network_quality_quality_data_connection",
								stations: [1],
								description: ["Unit has quality connection to data services and provider"],
								images: null
							}
						]
					},
					{
						name: "Soaking Period",
						description: null,
						items: [
							{
								name: "Started Outside Soaking",
								slug: "unit_readiness_documentation_soaking",
								stations: [1],
								description: ["Unit has been tested inside (QC'd and documentation completed), and outside for soaking period outside."],
								images: null
							},
							{
								name: "24-hour soak complete",
								slug: "unit_readiness_documentation_soaking_period_24_hour_soak_complete",
								stations: [1],
								description: ["Unit has been outside for a minimum of 24 hours and fully working"],
								images: ["70.png"]
							}
						]
					},
					{
						name: "Final Visual Inspections",
						description: "Conduct full visual inspections prior to finalizing and signing off the unit",
						items: [
							{
								name: "Boxes inspection",
								slug: "unit_readiness_documentation_final_visual_inspections_boxes_inspection",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Masthead inspection",
								slug: "unit_readiness_documentation_final_visual_inspections_masthead_inspection",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Trailer inspection",
								slug: "unit_readiness_documentation_final_visual_inspections_trailer_inspection",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Labels inspection",
								slug: "unit_readiness_documentation_final_visual_inspections_labels_inspection",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Solar Panels/Wrack inspection",
								slug: "unit_readiness_documentation_final_visual_inspections_solar_panels_wrack_inspection",
								stations: [1],
								description: [],
								images: null
							},
							{
								name: "Removal of Film",
								slug: "unit_readiness_documentation_final_visual_inspections_removal_film",
								stations: [1],
								description: ['Remove all protective film from Battery Monitor, Cameras, Solar Panels, and Compute Box.'],
								images: null
							}
						]
					},
					{
						name: "Ready to Ship",
						description: null,
						items: [
							{
								name: "Jack-Locks Packed",
								slug: "unit_readiness_documentation_ready_to_ship_jack_locks_packed",
								stations: [1],
								description: ["The unit has 4 (four) jack-locks packed in the Storage Box."],
								images: null
							},
							{
								name: "Keys Lock Box Attached",
								slug: "unit_readiness_documentation_ready_to_ship_keys_lock_box_attached",
								stations: [1],
								description: ["Set of keys are attached to in a lock box attached to the exterior of the trailer.", "The lock box code is using last digits of the VIN.", "Identify the lock box code in Details.", "<b>NOTE:</b> If no lock box is used, indicate 'N/A' in Details.", "<b>IMPORTANT:</b> Ensure the lock box is securely fastened to the trailer (outside on the tongue) and lock box is set to <b>last 4 digits of the VIN</b>. Put details with of the lock box # (1769) in the details."],
								images: null
							}, {
								name: "Winch Lock is applied",
								slug: "which_lock_is_applied",
								stations: [1],
								description: ["Using the Lock Box, on the Camera Mast there is a Lock Box that can store keys and lock the winch handle in place.", "Code should be set to <b>1769</b>"],
								images: null
							},
							{
								name: "Keys Packed",
								slug: "unit_readiness_documentation_ready_to_ship_keys_packed",
								stations: [1],
								description: ["Set of keys are packed in the Storage Box and in the Lock Box."],
								images: null
							},
							{
								name: "Flock Approved 'Ready to Ship'",
								slug: "unit_readiness_documentation_ready_to_ship_unit_ready_to_ship_by_flock",
								stations: [1],
								description: ["The unit has been approved by Flock as 'Ready to Ship' from their systems."],
								images: null
							},
							{
								name: "Unit ready to ship",
								slug: "unit_readiness_documentation_ready_to_ship_unit_ready_to_ship",
								stations: [1],
								description: ["The unit has been fully inspected, tested, and operated"],
								images: null
							}
						]
					}
				]
			},
			{
				category: "Logistics",
				description: null,
				sections: [
					{
						name: "Shipping Information",
						description: null,
						items: [
							{
								name: "Shipping Address",
								slug: "logistics_shipping_information_shipping_address",
								stations: [1],
								description: ["Shipping address for the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "logistics_shipping_information_shipping_address_name",
										placeholder: "Name of location",
										description: "Location of where unit is being shipped."
									},
									{
										label: "Address",
										type: "text",
										id: "logistics_shipping_information_shipping_address_address",
										placeholder: "Full address",
										description: "Full address of where unit is being shipped."
									}
								]
							},
							{
								name: "Carrier",
								slug: "logistics_shipping_information_carrier",
								stations: [1],
								description: ["Carrier responsible for shipping the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Carrier Name",
										type: "text",
										id: "logistics_shipping_information_carrier_carrier_name",
										placeholder: "Enter carrier name",
										description: "Name of the carrier responsible for shipping the unit."
									}
								]
							}, {
								name: "Shipping Date",
								slug: "logistics_shipping_information_shipping_date",
								stations: [1],
								description: ["Date the unit is shipped"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Shipping Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_shipping_date",
										placeholder: "Select shipping date",
										description: "Date the unit is shipped."
									}, {
										label: "Estimated Arrival Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_estimated_arrival_date",
										placeholder: "Select estimated arrival date",
										description: "Estimated date the unit will arrive at the destination."
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Unit Sign-Off",
				description: null,
				sections: [
					{
						name: "Final Sign-Off",
						description: null,
						items: [
							{
								name: "Final Sign-Off",
								slug: "final",
								stations: [100],
								description: ["This unit has been fully inspected, tested, and operated to the best of my ability.", "I approve this unit to be shipped to the customer.", "This unit aligns to the 'Golden Rule' and meets the standards of RVMP quality and care.", "Name and date required."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "final_signoff_user",
										placeholder: "Enter your name",
										description: "You digitally sign this document to approve the unit for shipment."
									}
								]
							}
						]
					}
				]
			}
		]
	}, {
		v2: [
			{
				category: "Overview",
				description: "Enter information about the unit.",
				sections: [
					{
						name: "Unit Overview",
						description: null,
						items: [
							{
								name: "Unit Identifiers",
								slug: "unit_identifiers",
								stations: [0],
								description: ["Overview of the unit."],
								hideCheckbox: true,
								form: [
									{
										label: "Unit VIN",
										type: "tel",
										id: "VIN",
										placeholder: "Enter VIN Number",
										maxLength: 17,
										pattern: "^[A-HJ-NPR-Z0-9]{11,17}$",
										description: "Vehicle Identification Number (11-17 chars).",
										overrideComponent: "vin"

									},
									{
										label: "Unit Identifier (name)",
										type: "text",
										id: "unit_identifiers_unit_identifier_name",
										placeholder: "e.g. Flock Trailer 251234566",
										description: `Human-readable or &quot;speakable&quot; identifier for the unit (asset name or label). <br /> &bull; Name should be 'Flock Trailer ' + 'Two Digit of Year' + 'Unit Number' (last 6 digits of the VIN) + ' ' + 'VIN' + <br />&bull; Example: 'Flock Trailer 2512345656'`
									},
									{
										label: "Unit Model",
										type: "text",
										id: "unit_identifiers_unit_model",
										placeholder: "Enter unit model",
										defaultValue: "Flock Trailer",
										description: "Official model name or number printed on the unit/plate."
									},
									{
										label: "Unit Version",
										type: "text",
										id: "unit_identifiers_make_unit_version",
										placeholder: "Enter make/unit version",
										defaultValue: "1.0.1",
										description: "Manufacturer version of hardware/firmware/components."
									},
									{
										label: "Unit Year",
										type: "number",
										id: "unit_identifiers_unit_year",
										placeholder: "YYYY",
										min: 1900,
										max: 2100,
										step: 1,
										defaultValue: new Date().getFullYear().toString(),
										description: "Model or manufacturing year of the unit (four digits)."
									},
								]
							},
							{
								name: "Victron Details",
								slug: "victron",
								stations: [0],
								description: ["Details about Victron components.", "Make sure all components are showing in the VRM portal:", "&bull; Go to <b>Advanced</b> &gt; Widgets (top right icon) &gt; Click on each and <b>'Enable All'</b> "],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "VRM Link",
										type: "url",
										id: "victron_vrm_link",
										placeholder: "https://vrm.victronenergy.com/...",
										description: "Direct URL to the unit in Victron VRM."
									},
									{
										label: "'Victron Cerbo GX' Serial Number",
										type: "text",
										id: "victron_victron_cerbo_gx_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Cerbo GX."
									},
									{
										label: "'SmartSolar Charge Controller MPPT 150A' Serial Number",
										type: "text",
										id: "victron_charge_controller_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartSolar Charge Controller."
									},
									{
										label: "'Orion-Tr 12v|24v - 10A' Serial Number",
										type: "text",
										id: "victron_orion_tr_12v_24v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr 12v|24v."
									},
									{
										label: "'Orion-Tr Smart 12v|48v - 8A' Serial Number",
										type: "text",
										id: "victron_orion_tr_smart_12v_48v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr Smart 12v|48v."
									},
									{
										label: "'SmartCharger 12v|50A'. Serial Number",
										type: "text",
										id: "victron_smartcharger_12v_50a_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartCharger 12v|50A."
									},
									{
										label: "Victron Battery Monitor Serial Number",
										type: "text",
										id: "victron_victron_battery_monitor_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Battery Monitor."
									}
								]
							},


							{
								name: "Victron Details",
								slug: "victron",
								stations: [0],
								description: ["Details about Victron components.", "Make sure all components are showing in the VRM portal:", "&bull; Go to <b>Advanced</b> &gt; Widgets (top right icon) &gt; Click on each and <b>'Enable All'</b> "],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "VRM Link",
										type: "url",
										id: "victron_vrm_link",
										placeholder: "https://vrm.victronenergy.com/...",
										description: "Direct URL to the unit in Victron VRM."
									},
									{
										label: "'Victron Cerbo GX' Serial Number",
										type: "text",
										id: "victron_victron_cerbo_gx_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Cerbo GX."
									},
									{
										label: "'SmartSolar Charge Controller MPPT 150A' Serial Number",
										type: "text",
										id: "victron_charge_controller_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartSolar Charge Controller."
									},
									{
										label: "'Orion-Tr 12v|24v - 10A' Serial Number",
										type: "text",
										id: "victron_orion_tr_12v_24v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr 12v|24v."
									},
									{
										label: "'Orion-Tr Smart 12v|48v - 8A' Serial Number",
										type: "text",
										id: "victron_orion_tr_smart_12v_48v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr Smart 12v|48v."
									},
									{
										label: "'SmartCharger 12v|50A'. Serial Number",
										type: "text",
										id: "victron_smartcharger_12v_50a_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartCharger 12v|50A."
									},
									{
										label: "Victron Battery Monitor Serial Number",
										type: "text",
										id: "victron_victron_battery_monitor_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Battery Monitor."
									}
								]
							},

							{
								name: "Modem (Power Box)",
								slug: "modem_power_box",
								stations: [0],
								description: ["The cellular modem located in the Power Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Modem (Power Box) Make",
										type: "text",
										id: "modem_power_box_modem_power_box_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the Power Box modem.",
										defaultValue: "Sierra Wireless"
									},
									{
										label: "Modem (Power Box) Model",
										type: "text",
										id: "modem_power_box_modem_power_box_model",
										placeholder: "Enter model",
										description: "Model name or number of the Power Box modem.",
										defaultValue: "6001124"
									},
									{
										label: "Modem (Power Box) Serial Number",
										type: "text",
										id: "modem_power_box_modem_power_box_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the Power Box modem.",
										defaultValue: "N/A"
									}
								]
							},

							{
								name: "Compute Box",
								slug: "compute_box",
								stations: [0],
								description: ["Enter details about the Compute Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Compute Box Make",
										type: "text",
										id: "compute_box_compute_box_make",
										placeholder: "Enter Maker",
										description: "Maker of the Compute Box",
										defaultValue: "Flock"
									},
									{
										label: "Compute Box Model",
										type: "text",
										id: "compute_box_compute_box_model",
										placeholder: "Enter Model",
										description: "Model of the Compute Box",
										defaultValue: "705-00010"
									},
									{
										label: "Compute Box Version",
										type: "text",
										id: "compute_box_compute_box_version",
										placeholder: "Enter Version",
										description: "Version assigned to the Compute Box.",
										defaultValue: "1.1.0"
									},
									{
										label: "Date Created of Compute Box",
										type: "text",
										id: "compute_box_compute_box_date_created",
										placeholder: "Enter Date Created",
										description: "Date when the Compute Box was created.",
										defaultValue: (new Date()).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
									},
									{
										label: "Compute Box Serial Number",
										type: "text",
										id: "compute_box_compute_box_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number assigned to the Compute Box."
									}
								]
							},

							{
								name: "PoE Switch",
								slug: "poe_switch",
								stations: [0],
								description: ["Manufacturer/brand and serial for the PoE switch."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "PoE Switch Make",
										type: "text",
										id: "poe_switch_poe_switch_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the PoE switch.",
										defaultValue: "Linovision"
									},
									{
										label: "PoE Switch Model",
										type: "text",
										id: "poe_switch_poe_switch_model",
										placeholder: "Enter model",
										description: "Model of the PoE switch.",
										defaultValue: "8-Port (POE-SW508G2)"
									},
									{
										label: "PoE Switch Serial Number",
										type: "text",
										id: "poe_switch_poe_switch_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the PoE switch.",
										defaultValue: "N/A"
									}
								]
							}

						]
					}
				]
			},
			{
				category: "Station 1",
				description: null,
				sections: [
					{
						name: `Frame &amp; Chassis`,
						description: null,
						slug: "frame_chassis",
						items: [
							{
								name: `Wheel Lugs Torque`,
								slug: "CQC-1_wheel_lugs_torque",
								stations: [1],
								cqc: "CQC-1",
								description: [
									`<u>All</u> wheel lugs torqued to <b>80 ft-lb</b>`,
									`NOTE: Values recorded <b><u>per</u> wheel</b>`
								],
								images: null
							}
							,
							{
								name: `Stabilizing Jacks`,
								slug: "CQC-2_stabilizing_jacks",
								stations: [1],
								cqc: "CQC-2",
								description: [
									`4 jacks installed`,
									`3 full up/down cycles each`,
									`No binding or abnormal behavior`
								],
								images: null
							}
							,
							{
								name: `Locking Pins`,
								slug: "CQC-3_locking_pins",
								stations: [1],
								cqc: "CQC-3",
								description: [
									`Pins extend/retract and lock`,
									`3 total cycles`,
									`No deformation or sticking`
								],
								images: null
							}
							,
							{
								name: `Tongue Jack`,
								slug: "CQC-4_tongue_jack",
								stations: [1],
								cqc: "CQC-4",
								description: [
									`Tongue jack operates up/down, swivels, and locks`,
									`No visible defects`
								],
								images: null
							}
							,
							{
								name: `Strobes`,
								slug: "CQC-5_strobes",
								stations: [1],
								cqc: "CQC-5",
								description: [
									`2 strobes installed and operational`
								],
								images: null
							}
							,
							{
								name: `Covers, Tread, Chains, Vin`,
								slug: "CQC-7_covers_tread_chains_vin",
								stations: [1],
								cqc: "CQC-7",
								description: [
									`Step-tread secure`,
									`Chains secure`,
									`VIN tag present at specified location`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 2",
				description: null,
				sections: [
					{
						name: `Box Striping / Drilling / Branding`,
						description: null,
						slug: "box_striping_drilling_branding",
						items: [
							{
								name: `Graphics Quality`,
								slug: "CQC-1_graphics_quality",
								stations: [2],
								cqc: "CQC-1",
								description: [
									`<u>All</u> boxes branded`,
									`Stripes/decals aligned`,
									`No bubbles or misprints`,
									`Unit Label on Power Box`
								],
								images: null
							}
							,
							{
								name: `Locks &amp; Keys`,
								slug: "CQC-2_locks_keys",
								stations: [2],
								cqc: "CQC-2",
								description: [
									`Storage boxes lock/unlock with specified key families (CH545, T001, 751)`,
									`2 keys per lock family provided`,
									`<ul><li>Power/Storage Box: CH545 or T001</li><li>Generator Box: 751</li><li>Masthead: 751</li></ul>`,
									`If keys not provided, note in Details section`,
								],
								images: null
							}
							,
							{
								name: `Struts`,
								slug: "CQC-3_struts",
								stations: [2],
								cqc: "CQC-3",
								description: [
									`Lids open/close smoothly`,
									`Struts hold lids`,
									`No excessive play`
								],
								images: null
							}
							,
							{
								name: `Box Condition`,
								slug: "CQC-4_box_condition",
								stations: [2],
								cqc: "CQC-4",
								description: [
									`Boxes free of scratches/dents beyond spec`,
									`Vents/holes only as specified`
								],
								images: null
							}
							,
							{
								name: `Warning Labels &amp; Placement`,
								slug: "CQC-5_warning_labels_placement",
								stations: [2],
								cqc: "CQC-5",
								description: [
									`“Call 911” (2/unit), Cord Warning, Level Warnings, Surveillance Notice, Lithium Battery Warning applied in specified locations and legible`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 3",
				description: null,
				sections: [
					{
						name: `Camera Mast &amp; Storage Boxes`,
						description: null,
						slug: "camera_mast_storage_boxes",
						items: [
							{
								name: `Mast Cycling`,
								slug: "CQC-1_mast_cycling",
								stations: [3],
								cqc: "CQC-1",
								description: [
									`Mast extends/retracts smoothly for 3 full cycles`,
									`No catching or misalignment`
								],
								images: null
							}
							,
							{
								name: `Winch Securement`,
								slug: "CQC-2_winch_securement",
								stations: [3],
								cqc: "CQC-2",
								description: [
									`Winch welds/bolts intact`,
									`No deformation or looseness under load. Holes Drilled for Lockbox`
								],
								images: null
							}
							,
							{
								name: `Cable &amp; Tension`,
								slug: "CQC-3_cable_tension",
								stations: [3],
								cqc: "CQC-3",
								description: [
									`Cable free of kinks/frays`,
									`Correctly routed`,
									`Tension set to spec`
								],
								images: null
							}
							,
							{
								name: `Lubrication`,
								slug: "CQC-4_lubrication",
								stations: [3],
								cqc: "CQC-4",
								description: [
									`Wormwheel and internal pucks visibly lubricated at all required points`
								],
								images: null
							}
							,
							{
								name: `Mast Finish &amp; Graphics`,
								slug: "CQC-5_mast_finish_graphics",
								stations: [3],
								cqc: "CQC-5",
								description: [
									`Mast surfaces free of major scratches/dents`,
									`Graphics correct and undamaged`
								],
								images: null
							}
							,
							{
								name: `Storage Boxes`,
								slug: "CQC-6_storage_boxes",
								stations: [3],
								cqc: "CQC-6",
								description: [
									`Storage boxes installed`,
									`Graphics/locks/struts meet ST-02 CQC requirements`
								],
								images: null
							},
							{
								name: "Cord reel cover",
								slug: "frame_chassis_cord_reel_cover",
								stations: [3],
								description: ["Cord reel cover has been installed", "Coiled cord is not visible"]
							}
						]
					}
				]
			}
			,
			{
				category: "Station 4",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Battery Torque`,
								slug: "CQC-1_battery_torque",
								stations: [4],
								cqc: "CQC-1",
								description: [
									`<u>All</u> battery, shunt, and disconnect terminals torqued to 100 in-lb`,
									`Values recorded per post`
								],
								images: null
							}
							,
							{
								name: `Modem / Gps`,
								slug: "CQC-4_modem_gps",
								stations: [4],
								cqc: "CQC-4",
								description: [
									`Modem powered and connected to provider`,
									`GPS puck installed`,
									`Cerbo reports valid location`
								],
								images: null
							}
							,
							{
								name: `Vrm Readiness`,
								slug: "CQC-5_vrm_readiness",
								stations: [4],
								cqc: "CQC-5",
								description: [
									`<u>All</u> Victron components visible in VRM`,
									`Timestamps correct`,
									`VRM name set`,
									`Transferred to customer account when required`
								],
								images: null
							}
							,
							{
								name: `Battery Monitor &amp; Shunt`,
								slug: "CQC-6_battery_monitor_shunt",
								stations: [4],
								cqc: "CQC-6",
								description: [
									`BMV voltage correct`,
									`Shunt capacity set to 800 Ah`,
									`BMV display shows required fields (Power, SOC, etc.)`
								],
								images: null
							}
							,
							{
								name: `Shore / Solar Controls`,
								slug: "CQC-7_shore_solar_controls",
								stations: [4],
								cqc: "CQC-7",
								description: [
									`Cerbo shore-power state changes correctly`,
									`Solar breaker operation correctly affects PV status/readings`
								],
								images: null
							}
							,
							{
								name: `Bluetooth &amp; Pins`,
								slug: "CQC-8_bluetooth_pins",
								stations: [4],
								cqc: "CQC-8",
								description: [
									`BT disabled on Cerbo/SmartSolar/SmartCharger/BMV`,
									`BT enabled on DC-DCs`,
									`PINs set per current build ticket and recorded`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 5",
				description: null,
				sections: [
					{
						name: `Camera Housing &amp; Provisioning`,
						description: null,
						slug: "camera_housing_provisioning",
						items: [
							{
								name: `Housing &amp; Lock`,
								slug: "CQC-1_housing_lock",
								stations: [5],
								cqc: "CQC-1",
								description: [
									`Masthead housing free of defects`,
									`Door opens/closes smoothly`,
									`751 lock operates`,
									`Seal intact`
								],
								images: null
							}
							,
							{
								name: `Pinout Voltages`,
								slug: "CQC-2_pinout_voltages",
								stations: [5],
								cqc: "CQC-2",
								description: [
									`Masthead pinout: <ul><li>Pin 1 = 48v</li><li>Pin 2 = 20v</li><li>Pin 3 = 12v</li><li>Pins 4-6 = GND</li></ul>`,
									`Verified with test box`
								],
								images: null
							}
							,
							{
								name: `Cable Glands`,
								slug: "CQC-3_cable_glands",
								stations: [5],
								cqc: "CQC-3",
								description: [
									`<u>All</u> glands are black`,
									`Tightened and sealing`,
									`IP67 cords have even external length and proper strain relief`
								],
								images: null
							}
							,
							{
								name: `Beacon &amp; Relays`,
								slug: "CQC-4_beacon_relays",
								stations: [5],
								cqc: "CQC-4",
								description: [
									`Beacon mounted at Position-2`,
									`Relay-1 toggles beacon ON/OFF`,
									`Dependency on 12v "Strobe" breaker verified`
								],
								images: null
							}
							,
							{
								name: `Cameras &amp; Poe`,
								slug: "CQC-5_cameras_poe",
								stations: [5],
								cqc: "CQC-5",
								description: [
									`Two Uniview PTZ + one Axis camera mounted in correct positions`,
									`PoE switch has 48v`,
									`Relevant ports show link/activity lights`
								],
								images: null
							}
							,
							{
								name: `Compute Box`,
								slug: "CQC-6_compute_box",
								stations: [5],
								cqc: "CQC-6",
								description: [
									`Compute Box power LED correct`,
									`Power landed left / Ethernet right`,
									`QR/barcode labels applied and legible`
								],
								images: null
							}
							,
							{
								name: `Generator Securement`,
								slug: "gen_securement",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`Generator is bolted with two (2) bolts and secured in the box`
								],
								images: null
							}
							,
							{
								name: `LP Monitors`,
								slug: "lp_monitors_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP monitors in the storage box of the unit`,
									`Each LP monitor is to be tested for proper connection and functionality`,
									`Each LP monitor is associated to the unit's CerboGX`
								],
								images: null
							}
							,
							{
								name: `LP Tanks`,
								slug: "lp_tanks_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP tanks installed properly in the LP Box`,
									`There is an LP warning label on the outside of the box`
								],
								images: null
							}

						]
					}
				]
			}
			,
			{
				category: "Station 6",
				description: null,
				sections: [
					{
						name: `Solar Mast &amp; Pv Array`,
						description: null,
						slug: "solar_mast_pv_array",
						items: [
							{
								name: `Rack Mechanism`,
								slug: "CQC-1_rack_mechanism",
								stations: [6],
								cqc: "CQC-1",
								description: [
									`Solar rack fully extends/retracts`,
									`Locks engage/release`,
									`3 up/down cycles smooth and without binding`
								],
								images: null
							}
							,
							{
								name: `Panel Securement &amp; Condition`,
								slug: "CQC-2_panel_securement_condition",
								stations: [6],
								cqc: "CQC-2",
								description: [
									`Correct hardware installed and torqued`,
									`Panels free of defects`,
									`PV cords firmly attached and strain-relieved`
								],
								images: null
							}
							,
							{
								name: `Gas Strut`,
								slug: "CQC-3_gas_strut",
								stations: [6],
								cqc: "CQC-3",
								description: [
									`Gas strut installed correctly, hardware secure`,
									`No leaks or visible damage`,
									`Supports motion properly`
								],
								images: null
							}
							,
							{
								name: `Terminations &amp; Breaker`,
								slug: "CQC-4_terminations_breaker",
								stations: [6],
								cqc: "CQC-4",
								description: [
									`PV conductors landed on correct charge-controller terminals with correct polarity`,
									`Solar breaker toggles PV input ON/OFF`
								],
								images: null
							}
							,
							{
								name: `Vrm Solar Output`,
								slug: "CQC-5_vrm_solar_output",
								stations: [6],
								cqc: "CQC-5",
								description: [
									`Solar production (PV V/A/W) visible and updating in VRM`,
									`No persistent solar-related faults`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 7",
				description: null,
				sections: [
					{
						name: `Final Qc &amp; Soak`,
						description: null,
						slug: "final_qc_soak",
						items: [
							{
								name: `Connectivity`,
								slug: "CQC-1_connectivity",
								stations: [7],
								cqc: "CQC-1",
								description: [
									`Unit can "phone home"`,
									`Compute Box connects to services`,
									`Power-box modem has active provider connection and stable data`
								],
								images: null
							}
							,
							{
								name: `Visuals`,
								slug: "CQC-2_visuals",
								stations: [7],
								cqc: "CQC-2",
								description: [
									`Final visual inspection passes for Boxes, Masthead, Trailer, Labels, Solar Panels/Rack`,
									`No unresolved defects`
								],
								images: null
							}
							,
							{
								name: `24-Hour Soak`,
								slug: "unit_readiness_documentation_soaking",
								stations: [7],
								cqc: "CQC-3",
								description: [
									`Outdoor soak started and minimum 24-hour period completed`,
									`No unresolved alarms`,
									`VRM live throughout soak window`
								],
								images: null
							}
							,
							{
								name: `Keys &amp; Locks`,
								slug: "CQC-4_keys_locks",
								stations: [7],
								cqc: "CQC-4",
								description: [
									`Lock box mounted on tongue and set to code 1769`,
									`Winch lock applied with code 1769`,
									`Required keys packed and documented`
								],
								images: null
							}
							,
							{
								name: `Ship Approval`,
								slug: "CQC-5_ship_approval",
								stations: [7],
								cqc: "CQC-5",
								description: [
									`"Flock Approved - Ready to Ship" (or equivalent) recorded`,
									`No open NCRs blocking shipment`,
									`Comfirm in their <a href="https://docs.google.com/spreadsheets/d/1SPSPO9R6aYikiCZWz-fChUP-Y3knW_AKkMNfZujEoU0/edit?usp=sharing" target="_blank">Google Sheet</a>`
								],
								images: null
							}
							,
							{
								name: `AGS Installation`,
								slug: "ags_installation_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is properly installed and functioning correctly`
								],
								images: null
							}
							,
							{
								name: `Check Fuel Lines`,
								slug: "check_fuel_lines_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Conduct a pressure-based test to ensure LP lines work properly`
								],
								images: null
							}
							,
							{
								name: `AGS Functionality Test`,
								slug: "ags_functionality_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is functioning correctly`
								],
								images: null
							}
							,
							{
								name: `Generator Run Test (Outdoor)`,
								slug: "gen_run_test_outdoor",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Perform the generator run test with the unit outside`,
									`Generator must be tested in an outdoor environment`
								],
								images: null
							}

						]
					}
				]
			},
			{
				category: "PDI",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							,
							{
								name: `Voltages &amp; Breakers`,
								slug: "CQC-2_voltages_breakers",
								stations: [0],
								cqc: "CQC-2",
								description: [
									`20v and 48v rails present at test points`,
									`PV, 20v, 48v, Strobe and System breakers correctly energize/de-energize outputs`,
									`Tug Test on Solar Hookup`
								],
								images: null
							}
							,
							{
								name: `Relays &amp; Status`,
								slug: "CQC-3_relays_status",
								stations: [0],
								cqc: "CQC-3",
								description: [
									`Relay-1 toggles Beacon`,
									`Relay-2 toggles PoE switch`,
									`Cerbo reflects correct ON/OFF state`
								],
								images: null
							}
						]
					}
				]
			},

			{
				category: "Logistics",
				description: null,
				sections: [
					{
						name: "Shipping Information",
						description: null,
						items: [
							{
								name: "Shipping Address",
								slug: "logistics_shipping_information_shipping_address",
								stations: [99],
								description: ["Shipping address for the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "logistics_shipping_information_shipping_address_name",
										placeholder: "Name of location",
										description: "Name of where unit is being shipped. If unknown, enter 'N/A'."
									},
									{
										label: "Address",
										type: "text",
										id: "logistics_shipping_information_shipping_address_address",
										placeholder: "Full address",
										description: "Full address of where unit is being shipped. If unknown, enter 'N/A'."
									}
								]
							},
							{
								name: "Carrier",
								slug: "logistics_shipping_information_carrier",
								stations: [99],
								description: ["Carrier responsible for shipping the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Carrier Name",
										type: "text",
										id: "logistics_shipping_information_carrier_carrier_name",
										placeholder: "Enter carrier name",
										description: "Name of the carrier or shipping company responsible for shipping the unit. If unknown, enter 'N/A'."
									}
								]
							}, {
								name: "Shipping Date",
								slug: "logistics_shipping_information_shipping_date",
								stations: [99],
								description: ["Date the unit is shipped"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Shipping Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_shipping_date",
										placeholder: "Select shipping date",
										description: "Date the unit is shipped."
									}, {
										label: "Estimated Arrival Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_estimated_arrival_date",
										placeholder: "Select estimated arrival date",
										description: "Estimated date the unit will arrive at the destination. If unknown, enter same date as Shipping Date."
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Unit Sign-Off",
				description: null,
				sections: [
					{
						name: "Final Sign-Off",
						description: null,
						items: [
							{
								name: "Final Sign-Off",
								slug: "final",
								stations: [100],
								description: ["This unit has been fully inspected, tested, and operated to the best of my ability.", "I approve this unit to be shipped to the customer.", "This unit aligns to the 'Golden Rule' and meets the standards of RVMP quality and care.", "Name and date required."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "final_signoff_user",
										placeholder: "Enter your name",
										description: "You digitally sign this document to approve the unit for shipment."
									}
								]
							}
						]
					}
				]
			}
		]
	}, {
		v3: [
			{
				category: "Overview",
				description: "[V3] Enter information about the unit.",
				sections: [
					{
						name: "Unit Overview",
						description: null,
						items: [
							{
								name: "Unit Identifiers",
								slug: "unit_identifiers",
								stations: [0],
								description: ["Overview of the unit."],
								hideCheckbox: true,
								form: [
									{
										label: "Unit Model",
										type: "text",
										id: "unit_identifiers_unit_model",
										description: "Select the unit model type.",
										overrideComponent: "unitModel"
									},
									{
										label: "Unit VIN",
										type: "tel",
										id: "VIN",
										placeholder: "Enter VIN Number",
										maxLength: 17,
										pattern: "^[A-HJ-NPR-Z0-9]{11,17}$",
										description: "Vehicle Identification Number (11-17 chars).",
										overrideComponent: "vin"

									},
									{
										label: "Unit Identifier (name)",
										type: "text",
										id: "unit_identifiers_unit_identifier_name",
										placeholder: "e.g. Flock Trailer 251234566",
										description: `Human-readable or &quot;speakable&quot; identifier for the unit (asset name or label). <br /> &bull; Name should be 'Flock Trailer ' + 'Two Digit of Year' + 'Unit Number' (last 6 digits of the VIN) + ' ' + 'VIN' + <br />&bull; Example: 'Flock Trailer 2512345656'`
									},
									{
										label: "Unit Version",
										type: "text",
										id: "unit_identifiers_make_unit_version",
										placeholder: "Enter make/unit version",
										defaultValue: "1.0.1",
										description: "Manufacturer version of hardware/firmware/components."
									},
									{
										label: "Unit Year",
										type: "number",
										id: "unit_identifiers_unit_year",
										placeholder: "YYYY",
										min: 1900,
										max: 2100,
										step: 1,
										defaultValue: new Date().getFullYear().toString(),
										description: "Model or manufacturing year of the unit (four digits)."
									},
								]
							},
							{
								name: "Generator Details",
								slug: "gen_details",
								stations: [0],
								description: ["Enter details about the generator and related components."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Generator Model &amp; Serial",
										type: "text",
										id: "gen_gen_model",
										placeholder: "Enter model",
										defaultValue: "2800i",
										description: "Select generator model and enter serial number.",
										overrideComponent: "generatorSerial"
									},

									{
										label: "LP Monitor 1",
										type: "text",
										id: "gen_details_lp_monitor_1",
										placeholder: "Enter LP Monitor 1",
										description: "LP tank monitor device 1 connected to CerboGX.",
										defaultValue: "Mopeka"
									},
									{
										label: "LP Monitor 2",
										type: "text",
										id: "gen_details_lp_monitor_2",
										placeholder: "Enter LP Monitor 2",
										description: "LP tank monitor device 2 connected to CerboGX.",
										defaultValue: "Mopeka"
									},
									{
										label: "AGS Model",
										type: "text",
										id: "gen_details_ags_model",
										placeholder: "Enter AGS Model",
										description: "Automatic Generator Start module model.",
										defaultValue: "AGSv1 Module"
									},
									{
										label: "AGS Firmware",
										type: "text",
										id: "gen_details_ags_firmware",
										placeholder: "Enter AGS Firmware version",
										description: "Firmware version of the AGS module.",
										defaultValue: "5"
									}
								]
							},

							{
								name: "Victron Details",
								slug: "victron",
								stations: [0],
								description: ["Details about Victron components.", "Make sure all components are showing in the VRM portal:", "&bull; Go to <b>Advanced</b> &gt; Widgets (top right icon) &gt; Click on each and <b>'Enable All'</b> "],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Victron Power Panel Serial",
										type: "text",
										id: "power_panel_serial",
										placeholder: "25FFP02270000",
										description: "Select the prefix and enter the last 4 digits of the serial number on the Power Panel inside the Power Box.<br /><br /><b>VRM Name Format:</b><br />&bull; Flex Security - [Unit Name] - [Power Panel Serial] - [VIN]<br />&bull; Example: Flex Security - Flock Trailer 592380 - 25FFP02270001 - 1F9F1U410SA592380",
										overrideComponent: "powerPanelSerial"
									},
									{
										label: "VRM Link",
										type: "url",
										id: "victron_vrm_link",
										placeholder: "https://vrm.victronenergy.com/...",
										description: "Direct URL to the unit in Victron VRM."
									},
									{
										label: "'Victron Cerbo GX' Serial Number",
										type: "text",
										id: "victron_victron_cerbo_gx_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Cerbo GX."
									},
									{
										label: "'SmartSolar Charge Controller MPPT 150A' Serial Number",
										type: "text",
										id: "victron_charge_controller_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartSolar Charge Controller."
									},
									{
										label: "'Orion-Tr 12v|24v - 10A' Serial Number",
										type: "text",
										id: "victron_orion_tr_12v_24v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr 12v|24v."
									},
									{
										label: "'Orion-Tr Smart 12v|48v - 8A' Serial Number",
										type: "text",
										id: "victron_orion_tr_smart_12v_48v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr Smart 12v|48v."
									},
									{
										label: "'SmartCharger 12v|50A'. Serial Number",
										type: "text",
										id: "victron_smartcharger_12v_50a_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartCharger 12v|50A."
									},
									{
										label: "Victron Battery Monitor Serial Number",
										type: "text",
										id: "victron_victron_battery_monitor_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Battery Monitor."
									}
								]
							},

							{
								name: "Modem (Power Box)",
								slug: "modem_power_box",
								stations: [0],
								description: ["The cellular modem located in the Power Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Modem (Power Box) Make",
										type: "text",
										id: "modem_power_box_modem_power_box_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the Power Box modem.",
										defaultValue: "Sierra Wireless"
									},
									{
										label: "Modem (Power Box) Model",
										type: "text",
										id: "modem_power_box_modem_power_box_model",
										placeholder: "Enter model",
										description: "Model name or number of the Power Box modem.",
										defaultValue: "6001124"
									},
									{
										label: "Modem (Power Box) Serial Number",
										type: "text",
										id: "modem_power_box_modem_power_box_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the Power Box modem.",
										defaultValue: "N/A"
									}
								]
							},

							{
								name: "Compute Box",
								slug: "compute_box",
								stations: [0],
								description: ["Enter details about the Compute Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Compute Box Make",
										type: "text",
										id: "compute_box_compute_box_make",
										placeholder: "Enter Maker",
										description: "Maker of the Compute Box",
										defaultValue: "Flock"
									},
									{
										label: "Compute Box Model",
										type: "text",
										id: "compute_box_compute_box_model",
										placeholder: "Enter Model",
										description: "Model of the Compute Box",
										defaultValue: "705-00010"
									},
									{
										label: "Compute Box Version",
										type: "text",
										id: "compute_box_compute_box_version",
										placeholder: "Enter Version",
										description: "Version assigned to the Compute Box.",
										defaultValue: "1.1.0"
									},
									{
										label: "Date Created of Compute Box",
										type: "text",
										id: "compute_box_compute_box_date_created",
										placeholder: "Enter Date Created",
										description: "Date when the Compute Box was created.",
										defaultValue: (new Date()).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
									},
									{
										label: "Compute Box Serial Number",
										type: "text",
										id: "compute_box_compute_box_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number assigned to the Compute Box."
									}
								]
							},

							{
								name: "PoE Switch",
								slug: "poe_switch",
								stations: [0],
								description: ["Manufacturer/brand and serial for the PoE switch."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "PoE Switch Make",
										type: "text",
										id: "poe_switch_poe_switch_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the PoE switch.",
										defaultValue: "Linovision"
									},
									{
										label: "PoE Switch Model",
										type: "text",
										id: "poe_switch_poe_switch_model",
										placeholder: "Enter model",
										description: "Model of the PoE switch.",
										defaultValue: "8-Port (POE-SW508G2)"
									},
									{
										label: "PoE Switch Serial Number",
										type: "text",
										id: "poe_switch_poe_switch_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the PoE switch.",
										defaultValue: "N/A"
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Station 1",
				description: null,
				sections: [
					{
						name: `Frame &amp; Chassis`,
						description: null,
						slug: "frame_chassis",
						items: [
							{
								name: `Wheel Lugs Torque`,
								slug: "CQC-1_wheel_lugs_torque",
								stations: [1],
								cqc: "CQC-1",
								description: [
									`<u>All</u> wheel lugs torqued to <b>80 ft-lb</b>`,
									`NOTE: Values recorded <b><u>per</u> wheel</b>`
								],
								images: null
							}
							,
							{
								name: `Stabilizing Jacks`,
								slug: "CQC-2_stabilizing_jacks",
								stations: [1],
								cqc: "CQC-2",
								description: [
									`4 jacks installed`,
									`3 full up/down cycles each`,
									`No binding or abnormal behavior`
								],
								images: null
							}
							,
							{
								name: `Locking Pins`,
								slug: "CQC-3_locking_pins",
								stations: [1],
								cqc: "CQC-3",
								description: [
									`Pins extend/retract and lock`,
									`3 total cycles`,
									`No deformation or sticking`
								],
								images: null
							}
							,
							{
								name: `Tongue Jack`,
								slug: "CQC-4_tongue_jack",
								stations: [1],
								cqc: "CQC-4",
								description: [
									`Tongue jack operates up/down, swivels, and locks`,
									`No visible defects`
								],
								images: null
							}
							,
							{
								name: `Strobes`,
								slug: "CQC-5_strobes",
								stations: [1],
								cqc: "CQC-5",
								description: [
									`2 strobes installed and operational`
								],
								images: null
							}
							,
							{
								name: `Covers, Tread, Chains, Vin`,
								slug: "CQC-7_covers_tread_chains_vin",
								stations: [1],
								cqc: "CQC-7",
								description: [
									`Step-tread secure`,
									`Chains secure`,
									`VIN tag present at specified location`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 2",
				description: null,
				sections: [
					{
						name: `Box Striping / Drilling / Branding`,
						description: null,
						slug: "box_striping_drilling_branding",
						items: [
							{
								name: `Graphics Quality`,
								slug: "CQC-1_graphics_quality",
								stations: [2],
								cqc: "CQC-1",
								description: [
									`<u>All</u> boxes branded`,
									`Stripes/decals aligned`,
									`No bubbles or misprints`,
									`Unit Label on Power Box`
								],
								images: null
							}
							,
							{
								name: `Locks &amp; Keys`,
								slug: "CQC-2_locks_keys",
								stations: [2],
								cqc: "CQC-2",
								description: [
									`Storage boxes lock/unlock with specified key families (CH545, T001, 751)`,
									`2 keys per lock family provided`,
									`<ul><li>Power/Storage Box: CH545 or T001</li><li>Generator Box: 751</li><li>Masthead: 751</li></ul>`,
									`If keys not provided, note in Details section`,
								],
								images: null
							}
							,
							{
								name: `Struts`,
								slug: "CQC-3_struts",
								stations: [2],
								cqc: "CQC-3",
								description: [
									`Lids open/close smoothly`,
									`Struts hold lids`,
									`No excessive play`
								],
								images: null
							}
							,
							{
								name: `Box Condition`,
								slug: "CQC-4_box_condition",
								stations: [2],
								cqc: "CQC-4",
								description: [
									`Boxes free of scratches/dents beyond spec`,
									`Vents/holes only as specified`
								],
								images: null
							}
							,
							{
								name: `Warning Labels &amp; Placement`,
								slug: "CQC-5_warning_labels_placement",
								stations: [2],
								cqc: "CQC-5",
								description: [
									`“Call 911” (2/unit), Cord Warning, Level Warnings, Surveillance Notice, Lithium Battery Warning applied in specified locations and legible`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 3",
				description: null,
				sections: [
					{
						name: `Camera Mast &amp; Storage Boxes`,
						description: null,
						slug: "camera_mast_storage_boxes",
						items: [
							{
								name: `Mast Cycling`,
								slug: "CQC-1_mast_cycling",
								stations: [3],
								cqc: "CQC-1",
								description: [
									`Mast extends/retracts smoothly for 3 full cycles`,
									`No catching or misalignment`
								],
								images: null
							}
							,
							{
								name: `Winch Securement`,
								slug: "CQC-2_winch_securement",
								stations: [3],
								cqc: "CQC-2",
								description: [
									`Winch welds/bolts intact`,
									`No deformation or looseness under load. Holes Drilled for Lockbox`
								],
								images: null
							}
							,
							{
								name: `Cable &amp; Tension`,
								slug: "CQC-3_cable_tension",
								stations: [3],
								cqc: "CQC-3",
								description: [
									`Cable free of kinks/frays`,
									`Correctly routed`,
									`Tension set to spec`
								],
								images: null
							}
							,
							{
								name: `Lubrication`,
								slug: "CQC-4_lubrication",
								stations: [3],
								cqc: "CQC-4",
								description: [
									`Wormwheel and internal pucks visibly lubricated at all required points`
								],
								images: null
							}
							,
							{
								name: `Mast Finish &amp; Graphics`,
								slug: "CQC-5_mast_finish_graphics",
								stations: [3],
								cqc: "CQC-5",
								description: [
									`Mast surfaces free of major scratches/dents`,
									`Graphics correct and undamaged`
								],
								images: null
							}
							,
							{
								name: `Storage Boxes`,
								slug: "CQC-6_storage_boxes",
								stations: [3],
								cqc: "CQC-6",
								description: [
									`Storage boxes installed`,
									`Graphics/locks/struts meet ST-02 CQC requirements`
								],
								images: null
							},
							{
								name: "Cord reel cover",
								slug: "frame_chassis_cord_reel_cover",
								stations: [3],
								description: ["Cord reel cover has been installed", "Coiled cord is not visible"]
							}
						]
					}
				]
			}
			,
			{
				category: "Station 4",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Battery Torque`,
								slug: "CQC-1_battery_torque",
								stations: [4],
								cqc: "CQC-1",
								description: [
									`<u>All</u> battery, shunt, and disconnect terminals torqued to 100 in-lb`,
									`Values recorded per post`
								],
								images: null
							}
							,
							{
								name: `Modem / Gps`,
								slug: "CQC-4_modem_gps",
								stations: [4],
								cqc: "CQC-4",
								description: [
									`Modem powered and connected to provider`,
									`GPS puck installed`,
									`Cerbo reports valid location`
								],
								images: null
							}
							,
							{
								name: `Vrm Readiness`,
								slug: "CQC-5_vrm_readiness",
								stations: [4],
								cqc: "CQC-5",
								description: [
									`<u>All</u> Victron components visible in VRM`,
									`Timestamps correct`,
									`VRM name set`,
									`Transferred to customer account when required`
								],
								images: null
							}
							,
							{
								name: `Battery Monitor &amp; Shunt`,
								slug: "CQC-6_battery_monitor_shunt",
								stations: [4],
								cqc: "CQC-6",
								description: [
									`BMV voltage correct`,
									`Shunt capacity set to 800 Ah`,
									`BMV display shows required fields (Power, SOC, etc.)`
								],
								images: null
							}
							,
							{
								name: `Shore / Solar Controls`,
								slug: "CQC-7_shore_solar_controls",
								stations: [4],
								cqc: "CQC-7",
								description: [
									`Cerbo shore-power state changes correctly`,
									`Solar breaker operation correctly affects PV status/readings`
								],
								images: null
							}
							,
							{
								name: `Bluetooth &amp; Pins`,
								slug: "CQC-8_bluetooth_pins",
								stations: [4],
								cqc: "CQC-8",
								description: [
									`BT disabled on Cerbo/SmartSolar/SmartCharger/BMV`,
									`BT enabled on DC-DCs`,
									`PINs set per current build ticket and recorded`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 5",
				description: null,
				sections: [
					{
						name: `Camera Housing &amp; Provisioning`,
						description: null,
						slug: "camera_housing_provisioning",
						items: [
							{
								name: `Housing &amp; Lock`,
								slug: "CQC-1_housing_lock",
								stations: [5],
								cqc: "CQC-1",
								description: [
									`Masthead housing free of defects`,
									`Door opens/closes smoothly`,
									`751 lock operates`,
									`Seal intact`
								],
								images: null
							}
							,
							{
								name: `Pinout Voltages`,
								slug: "CQC-2_pinout_voltages",
								stations: [5],
								cqc: "CQC-2",
								description: [
									`Masthead pinout: <ul><li>Pin 1 = 48v</li><li>Pin 2 = 20v</li><li>Pin 3 = 12v</li><li>Pins 4-6 = GND</li></ul>`,
									`Verified with test box`
								],
								images: null
							}
							,
							{
								name: `Cable Glands`,
								slug: "CQC-3_cable_glands",
								stations: [5],
								cqc: "CQC-3",
								description: [
									`<u>All</u> glands are black`,
									`Tightened and sealing`,
									`IP67 cords have even external length and proper strain relief`
								],
								images: null
							}
							,
							{
								name: `Beacon &amp; Relays`,
								slug: "CQC-4_beacon_relays",
								stations: [5],
								cqc: "CQC-4",
								description: [
									`Beacon mounted at Position-2`,
									`Relay-1 toggles beacon ON/OFF`,
									`Dependency on 12v "Strobe" breaker verified`
								],
								images: null
							}
							,
							{
								name: `Cameras &amp; Poe`,
								slug: "CQC-5_cameras_poe",
								stations: [5],
								cqc: "CQC-5",
								description: [
									`Two Uniview PTZ + one Axis camera mounted in correct positions`,
									`PoE switch has 48v`,
									`Relevant ports show link/activity lights`
								],
								images: null
							}
							,
							{
								name: `Compute Box`,
								slug: "CQC-6_compute_box",
								stations: [5],
								cqc: "CQC-6",
								description: [
									`Compute Box power LED correct`,
									`Power landed left / Ethernet right`,
									`QR/barcode labels applied and legible`
								],
								images: null
							}
							,
							{
								name: `Generator Securement`,
								slug: "gen_securement",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`Generator is bolted with two (2) bolts and secured in the box`
								],
								images: null
							}
							,
							{
								name: `LP Monitors`,
								slug: "lp_monitors_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP monitors in the storage box of the unit`,
									`Each LP monitor is to be tested for proper connection and functionality`,
									`Each LP monitor is associated to the unit's CerboGX`
								],
								images: null
							}
							,
							{
								name: `LP Tanks`,
								slug: "lp_tanks_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP tanks installed properly in the LP Box`,
									`There is an LP warning label on the outside of the box`
								],
								images: null
							}

						]
					}
				]
			}
			,
			{
				category: "Station 6",
				description: null,
				sections: [
					{
						name: `Solar Mast &amp; Pv Array`,
						description: null,
						slug: "solar_mast_pv_array",
						items: [
							{
								name: `Rack Mechanism`,
								slug: "CQC-1_rack_mechanism",
								stations: [6],
								cqc: "CQC-1",
								description: [
									`Solar rack fully extends/retracts`,
									`Locks engage/release`,
									`3 up/down cycles smooth and without binding`
								],
								images: null
							}
							,
							{
								name: `Panel Securement &amp; Condition`,
								slug: "CQC-2_panel_securement_condition",
								stations: [6],
								cqc: "CQC-2",
								description: [
									`Correct hardware installed and torqued`,
									`Panels free of defects`,
									`PV cords firmly attached and strain-relieved`
								],
								images: null
							}
							,
							{
								name: `Gas Strut`,
								slug: "CQC-3_gas_strut",
								stations: [6],
								cqc: "CQC-3",
								description: [
									`Gas strut installed correctly, hardware secure`,
									`No leaks or visible damage`,
									`Supports motion properly`
								],
								images: null
							}
							,
							{
								name: `Terminations &amp; Breaker`,
								slug: "CQC-4_terminations_breaker",
								stations: [6],
								cqc: "CQC-4",
								description: [
									`PV conductors landed on correct charge-controller terminals with correct polarity`,
									`Solar breaker toggles PV input ON/OFF`
								],
								images: null
							}
							,
							{
								name: `Vrm Solar Output`,
								slug: "CQC-5_vrm_solar_output",
								stations: [6],
								cqc: "CQC-5",
								description: [
									`Solar production (PV V/A/W) visible and updating in VRM`,
									`No persistent solar-related faults`
								],
								images: null
							}
						]
					}
				]
			}
			,
			{
				category: "Station 7",
				description: null,
				sections: [
					{
						name: `Final Qc &amp; Soak`,
						description: null,
						slug: "final_qc_soak",
						items: [
							{
								name: `Connectivity`,
								slug: "CQC-1_connectivity",
								stations: [7],
								cqc: "CQC-1",
								description: [
									`Unit can "phone home"`,
									`Compute Box connects to services`,
									`Power-box modem has active provider connection and stable data`
								],
								images: null
							}
							,
							{
								name: `Visuals`,
								slug: "CQC-2_visuals",
								stations: [7],
								cqc: "CQC-2",
								description: [
									`Final visual inspection passes for Boxes, Masthead, Trailer, Labels, Solar Panels/Rack`,
									`No unresolved defects`
								],
								images: null
							}
							,
							{
								name: `24-Hour Soak`,
								slug: "unit_readiness_documentation_soaking",
								stations: [7],
								cqc: "CQC-3",
								description: [
									`Outdoor soak started and minimum 24-hour period completed`,
									`No unresolved alarms`,
									`VRM live throughout soak window`
								],
								images: null
							}
							,
							{
								name: `Keys &amp; Locks`,
								slug: "CQC-4_keys_locks",
								stations: [7],
								cqc: "CQC-4",
								description: [
									`Lock box mounted on tongue and set to code 1769`,
									`Winch lock applied with code 1769`,
									`Required keys packed and documented`
								],
								images: null
							}
							,
							{
								name: `Ship Approval`,
								slug: "CQC-5_ship_approval",
								stations: [7],
								cqc: "CQC-5",
								description: [
									`"Flock Approved - Ready to Ship" (or equivalent) recorded`,
									`No open NCRs blocking shipment`,
									`Comfirm in their <a href="https://docs.google.com/spreadsheets/d/1SPSPO9R6aYikiCZWz-fChUP-Y3knW_AKkMNfZujEoU0/edit?usp=sharing" target="_blank">Google Sheet</a>`
								],
								images: null
							}
							,
							{
								name: `AGS Installation`,
								slug: "ags_installation_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is properly installed and functioning correctly`
								],
								images: null
							}
							,
							{
								name: `Check Fuel Lines`,
								slug: "check_fuel_lines_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Conduct a pressure-based test to ensure LP lines work properly`
								],
								images: null
							}
							,
							{
								name: `AGS Functionality Test`,
								slug: "ags_functionality_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is functioning correctly`
								],
								images: null
							}
							,
							{
								name: `Generator Run Test (Outdoor)`,
								slug: "gen_run_test_outdoor",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Perform the generator run test with the unit outside`,
									`Generator must be tested in an outdoor environment`
								],
								images: null
							}

						]
					}
				]
			},
			{
				category: "PDI",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Voltages &amp; Breakers`,
								slug: "CQC-2_voltages_breakers",
								stations: [0],
								cqc: "CQC-2",
								description: [
									`20v and 48v rails present at test points`,
									`PV, 20v, 48v, Strobe and System breakers correctly energize/de-energize outputs`,
									`Tug Test on Solar Hookup`
								],
								images: null,
								form: [
									{
										label: "Voltages & Breakers Photo",
										id: "CQC-2_voltages_breakers_photo",
										description: "Upload a photo showing the voltage readings and breaker configurations"
									},
								]
							}
						]
					},

					{
						name: `Photos`,
						description: null,
						slug: "unit_photos",
						items: [
							{
								name: `Unit Photo Side 1`,
								slug: "unit_photo_side_1",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Side 1",
										id: "photo_unit_side_1",
										overrideComponent: "image",
										description: "Upload a photo showing side 1 of the unit"
									}
								]
							}
							,
							{
								name: `Unit Photo Side 2`,
								slug: "unit_photo_side_2",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Side 2",
										id: "photo_unit_side_2",
										overrideComponent: "image",
										description: "Upload a photo showing side 2 of the unit"
									}
								]
							}
							,
							{
								name: `Unit Photo Front`,
								slug: "unit_photo_front",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Front",
										id: "photo_unit_front",
										overrideComponent: "image",
										description: "Upload a photo showing the front of the unit"
									}
								]
							}
							,
							{
								name: `Unit Photo Back`,
								slug: "unit_photo_back",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Back",
										id: "photo_unit_back",
										overrideComponent: "image",
										description: "Upload a photo showing the back of the unit"
									}
								]
							}
							,
							{
								name: `Power Panel Photo`,
								slug: "power_panel_photo",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Power Panel Photo",
										id: "photo_power_panel",
										overrideComponent: "image",
										description: "Upload a photo showing the power panel"
									}
								]
							}
							,
							{
								name: `Camera Housing Photo`,
								slug: "camera_housing_photo",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Camera Housing Photo",
										id: "photo_camera_housing",
										overrideComponent: "image",
										description: "Upload a photo showing the camera housing"
									}
								]
							}
						]
					}
				]
			},

			{
				category: "Logistics",
				description: null,
				sections: [
					{
						name: "Shipping Information",
						description: null,
						items: [
							{
								name: "Shipping Address",
								slug: "logistics_shipping_information_shipping_address",
								stations: [99],
								description: ["Shipping address for the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "logistics_shipping_information_shipping_address_name",
										placeholder: "Name of location",
										description: "Name of where unit is being shipped. If unknown, enter 'N/A'."
									},
									{
										label: "Address",
										type: "text",
										id: "logistics_shipping_information_shipping_address_address",
										placeholder: "Full address",
										description: "Full address of where unit is being shipped. If unknown, enter 'N/A'."
									}
								]
							},
							{
								name: "Carrier",
								slug: "logistics_shipping_information_carrier",
								stations: [99],
								description: ["Carrier responsible for shipping the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Carrier Name",
										type: "text",
										id: "logistics_shipping_information_carrier_carrier_name",
										placeholder: "Enter carrier name",
										description: "Name of the carrier or shipping company responsible for shipping the unit. If unknown, enter 'N/A'."
									}
								]
							}, {
								name: "Shipping Date",
								slug: "logistics_shipping_information_shipping_date",
								stations: [99],
								description: ["Date the unit is shipped"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Shipping Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_shipping_date",
										placeholder: "Select shipping date",
										description: "Date the unit is shipped."
									}, {
										label: "Estimated Arrival Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_estimated_arrival_date",
										placeholder: "Select estimated arrival date",
										description: "Estimated date the unit will arrive at the destination. If unknown, enter same date as Shipping Date."
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Unit Sign-Off",
				description: null,
				sections: [
					{
						name: "Final Sign-Off",
						description: null,
						items: [
							{
								name: "Final Sign-Off",
								slug: "final",
								stations: [100],
								description: ["This unit has been fully inspected, tested, and operated to the best of my ability.", "I approve this unit to be shipped to the customer.", "This unit aligns to the 'Golden Rule' and meets the standards of RVMP quality and care.", "Name and date required."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "final_signoff_user",
										placeholder: "Enter your name",
										description: "You digitally sign this document to approve the unit for shipment."
									}
								]
							}
						]
					}
				]
			}
		]
	}, {
		v4: [
			{
				category: "Overview",
				description: "[V3] Enter information about the unit.",
				sections: [
					{
						name: "Unit Overview",
						description: null,
						items: [
							{
								name: "Unit Identifiers",
								slug: "unit_identifiers",
								stations: [0],
								description: ["Overview of the unit."],
								hideCheckbox: true,
								form: [
									{
										label: "Unit Model",
										type: "text",
										id: "unit_identifiers_unit_model",
										description: "Select the unit model type.",
										overrideComponent: "unitModel",
										required: true,
									},
									{
										label: "Unit VIN",
										type: "tel",
										id: "VIN",
										placeholder: "Enter VIN Number",
										maxLength: 17,
										pattern: "^[A-HJ-NPR-Z0-9]{11,17}$",
										description: "Vehicle Identification Number (11-17 chars).",
										overrideComponent: "vin",
										required: true,

									},
									{
										label: "Unit Identifier (name)",
										type: "text",
										id: "unit_identifiers_unit_identifier_name",
										placeholder: "e.g. Flock Trailer 251234566",
										description: `Human-readable or &quot;speakable&quot; identifier for the unit (asset name or label). <br /> &bull; Name should be 'Flock Trailer ' + 'Two Digit of Year' + 'Unit Number' (last 6 digits of the VIN) + ' ' + 'VIN' + <br />&bull; Example: 'Flock Trailer 2512345656'`,
										required: true,
									},
									{
										label: "Unit Version",
										type: "text",
										id: "unit_identifiers_make_unit_version",
										placeholder: "Enter make/unit version",
										defaultValue: "1.0.1",
										description: "Manufacturer version of hardware/firmware/components.",
										required: true,
									},
									{
										label: "Unit Year",
										type: "number",
										id: "unit_identifiers_unit_year",
										placeholder: "YYYY",
										min: 1900,
										max: 2100,
										step: 1,
										defaultValue: new Date().getFullYear().toString(),
										description: "Model or manufacturing year of the unit (four digits).",
										required: true,
									},
								]
							},
							{
								name: "Generator Details",
								slug: "gen_details",
								stations: [0],
								description: ["Enter details about the generator and related components."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Generator Model &amp; Serial",
										type: "text",
										id: "gen_gen_model",
										placeholder: "Enter model",
										defaultValue: "2800i",
										description: "Select generator model and enter serial number.",
										overrideComponent: "generatorSerial",
										required: true,
									},

									{
										label: "LP Monitor 1",
										type: "text",
										id: "gen_details_lp_monitor_1",
										placeholder: "Enter LP Monitor 1",
										description: "LP tank monitor device 1 connected to CerboGX.",
										defaultValue: "Mopeka",
										required: true,
									},
									{
										label: "LP Monitor 2",
										type: "text",
										id: "gen_details_lp_monitor_2",
										placeholder: "Enter LP Monitor 2",
										description: "LP tank monitor device 2 connected to CerboGX.",
										defaultValue: "Mopeka",
										required: true,
									},
									{
										label: "AGS Model",
										type: "text",
										id: "gen_details_ags_model",
										placeholder: "Enter AGS Model",
										description: "Automatic Generator Start module model.",
										defaultValue: "AGSv1 Module",
										required: true,
									},
									{
										label: "AGS Firmware",
										type: "text",
										id: "gen_details_ags_firmware",
										placeholder: "Enter AGS Firmware version",
										description: "Firmware version of the AGS module.",
										defaultValue: "5",
										required: true,
									}
								]
							},

							{
								name: "Victron Details",
								slug: "victron",
								stations: [0],
								description: ["Details about Victron components.", "Make sure all components are showing in the VRM portal:", "&bull; Go to <b>Advanced</b> &gt; Widgets (top right icon) &gt; Click on each and <b>'Enable All'</b> "],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Victron Power Panel Serial",
										type: "text",
										id: "power_panel_serial",
										placeholder: "25FFP02270000",
										description: "Select the prefix and enter the last 4 digits of the serial number on the Power Panel inside the Power Box.<br /><br /><b>VRM Name Format:</b><br />&bull; Flex Security - [Unit Name] - [Power Panel Serial] - [VIN]<br />&bull; Example: Flex Security - Flock Trailer 592380 - 25FFP02270001 - 1F9F1U410SA592380",
										overrideComponent: "powerPanelSerial",
										required: true,
									},
									{
										label: "VRM Link",
										type: "url",
										id: "victron_vrm_link",
										placeholder: "https://vrm.victronenergy.com/...",
										description: "Direct URL to the unit in Victron VRM."
									},
									{
										label: "'Victron Cerbo GX' Serial Number",
										type: "text",
										id: "victron_victron_cerbo_gx_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Cerbo GX."
									},
									{
										label: "'SmartSolar Charge Controller MPPT 150A' Serial Number",
										type: "text",
										id: "victron_charge_controller_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartSolar Charge Controller."
									},
									{
										label: "'Orion-Tr 12v|24v - 10A' Serial Number",
										type: "text",
										id: "victron_orion_tr_12v_24v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr 12v|24v."
									},
									{
										label: "'Orion-Tr Smart 12v|48v - 8A' Serial Number",
										type: "text",
										id: "victron_orion_tr_smart_12v_48v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr Smart 12v|48v."
									},
									{
										label: "'SmartCharger 12v|50A'. Serial Number",
										type: "text",
										id: "victron_smartcharger_12v_50a_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartCharger 12v|50A."
									},
									{
										label: "Victron Battery Monitor Serial Number",
										type: "text",
										id: "victron_victron_battery_monitor_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Battery Monitor."
									}
								]
							},

							{
								name: "Modem (Power Box)",
								slug: "modem_power_box",
								stations: [0],
								description: ["The cellular modem located in the Power Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Modem (Power Box) Make",
										type: "text",
										id: "modem_power_box_modem_power_box_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the Power Box modem.",
										defaultValue: "Sierra Wireless"
									},
									{
										label: "Modem (Power Box) Model",
										type: "text",
										id: "modem_power_box_modem_power_box_model",
										placeholder: "Enter model",
										description: "Model name or number of the Power Box modem.",
										defaultValue: "6001124"
									},
									{
										label: "Modem (Power Box) Serial Number",
										type: "text",
										id: "modem_power_box_modem_power_box_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the Power Box modem.",
										defaultValue: "N/A"
									}
								]
							},

							{
								name: "Compute Box",
								slug: "compute_box",
								stations: [0],
								description: ["Enter details about the Compute Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Compute Box Make",
										type: "text",
										id: "compute_box_compute_box_make",
										placeholder: "Enter Maker",
										description: "Maker of the Compute Box",
										defaultValue: "Flock",
										required: true,
									},
									{
										label: "Compute Box Model",
										type: "text",
										id: "compute_box_compute_box_model",
										placeholder: "Enter Model",
										description: "Model of the Compute Box",
										defaultValue: "705-00010",
										required: true,
									},
									{
										label: "Compute Box Version",
										type: "text",
										id: "compute_box_compute_box_version",
										placeholder: "Enter Version",
										description: "Version assigned to the Compute Box.",
										defaultValue: "1.1.0",
										required: true,
									},
									{
										label: "Date Created of Compute Box",
										type: "text",
										id: "compute_box_compute_box_date_created",
										placeholder: "Enter Date Created",
										description: "Date when the Compute Box was created.",
										defaultValue: (new Date()).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
									},
									{
										label: "Compute Box Serial Number",
										type: "text",
										id: "compute_box_compute_box_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number assigned to the Compute Box.",
										required: true,
									}
								]
							},

							{
								name: "PoE Switch",
								slug: "poe_switch",
								stations: [0],
								description: ["Manufacturer/brand and serial for the PoE switch."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "PoE Switch Make",
										type: "text",
										id: "poe_switch_poe_switch_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the PoE switch.",
										defaultValue: "Linovision",
										required: true,
									},
									{
										label: "PoE Switch Model",
										type: "text",
										id: "poe_switch_poe_switch_model",
										placeholder: "Enter model",
										description: "Model of the PoE switch.",
										defaultValue: "8-Port (POE-SW508G2)",
										required: true,
									},
									{
										label: "PoE Switch Serial Number",
										type: "text",
										id: "poe_switch_poe_switch_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the PoE switch.",
										defaultValue: "N/A"
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Station 1",
				description: null,
				sections: [
					{
						name: `Frame &amp; Chassis`,
						description: null,
						slug: "frame_chassis",
						items: [
							{
								name: `Wheel Lugs Torque`,
								slug: "CQC-1_wheel_lugs_torque",
								stations: [1],
								cqc: "CQC-1",
								description: [
									`<u>All</u> wheel lugs torqued to <b>80 ft-lb</b>`,
									`NOTE: Values recorded <b><u>per</u> wheel</b>`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Stabilizing Jacks`,
								slug: "CQC-2_stabilizing_jacks",
								stations: [1],
								cqc: "CQC-2",
								description: [
									`4 jacks installed`,
									`3 full up/down cycles each`,
									`No binding or abnormal behavior`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Locking Pins`,
								slug: "CQC-3_locking_pins",
								stations: [1],
								cqc: "CQC-3",
								description: [
									`Pins extend/retract and lock`,
									`3 total cycles`,
									`No deformation or sticking`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Tongue Jack`,
								slug: "CQC-4_tongue_jack",
								stations: [1],
								cqc: "CQC-4",
								description: [
									`Tongue jack operates up/down, swivels, and locks`,
									`No visible defects`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Strobes`,
								slug: "CQC-5_strobes",
								stations: [1],
								cqc: "CQC-5",
								description: [
									`2 strobes installed and operational`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Covers, Tread, Chains, Vin`,
								slug: "CQC-7_covers_tread_chains_vin",
								stations: [1],
								cqc: "CQC-7",
								description: [
									`Step-tread secure`,
									`Chains secure`,
									`VIN tag present at specified location`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 2",
				description: null,
				sections: [
					{
						name: `Box Striping / Drilling / Branding`,
						description: null,
						slug: "box_striping_drilling_branding",
						items: [
							{
								name: `Graphics Quality`,
								slug: "CQC-1_graphics_quality",
								stations: [2],
								cqc: "CQC-1",
								description: [
									`<u>All</u> boxes branded`,
									`Stripes/decals aligned`,
									`No bubbles or misprints`,
									`Unit Label on Power Box`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Locks &amp; Keys`,
								slug: "CQC-2_locks_keys",
								stations: [2],
								cqc: "CQC-2",
								description: [
									`Storage boxes lock/unlock with specified key families (CH545, T001, 751)`,
									`2 keys per lock family provided`,
									`<ul><li>Power/Storage Box: CH545 or T001</li><li>Generator Box: 751</li><li>Masthead: 751</li></ul>`,
									`If keys not provided, note in Details section`,
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Struts`,
								slug: "CQC-3_struts",
								stations: [2],
								cqc: "CQC-3",
								description: [
									`Lids open/close smoothly`,
									`Struts hold lids`,
									`No excessive play`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Box Condition`,
								slug: "CQC-4_box_condition",
								stations: [2],
								cqc: "CQC-4",
								description: [
									`Boxes free of scratches/dents beyond spec`,
									`Vents/holes only as specified`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Warning Labels &amp; Placement`,
								slug: "CQC-5_warning_labels_placement",
								stations: [2],
								cqc: "CQC-5",
								description: [
									`“Call 911” (2/unit), Cord Warning, Level Warnings, Surveillance Notice, Lithium Battery Warning applied in specified locations and legible`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 3",
				description: null,
				sections: [
					{
						name: `Camera Mast &amp; Storage Boxes`,
						description: null,
						slug: "camera_mast_storage_boxes",
						items: [
							{
								name: `Mast Cycling`,
								slug: "CQC-1_mast_cycling",
								stations: [3],
								cqc: "CQC-1",
								description: [
									`Mast extends/retracts smoothly for 3 full cycles`,
									`No catching or misalignment`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Winch Securement`,
								slug: "CQC-2_winch_securement",
								stations: [3],
								cqc: "CQC-2",
								description: [
									`Winch welds/bolts intact`,
									`No deformation or looseness under load. Holes Drilled for Lockbox`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Cable &amp; Tension`,
								slug: "CQC-3_cable_tension",
								stations: [3],
								cqc: "CQC-3",
								description: [
									`Cable free of kinks/frays`,
									`Correctly routed`,
									`Tension set to spec`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Lubrication`,
								slug: "CQC-4_lubrication",
								stations: [3],
								cqc: "CQC-4",
								description: [
									`Wormwheel and internal pucks visibly lubricated at all required points`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Mast Finish &amp; Graphics`,
								slug: "CQC-5_mast_finish_graphics",
								stations: [3],
								cqc: "CQC-5",
								description: [
									`Mast surfaces free of major scratches/dents`,
									`Graphics correct and undamaged`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Storage Boxes`,
								slug: "CQC-6_storage_boxes",
								stations: [3],
								cqc: "CQC-6",
								description: [
									`Storage boxes installed`,
									`Graphics/locks/struts meet ST-02 CQC requirements`
								],
								images: null,
								required: true,
							},
							{
								name: "Cord reel cover",
								slug: "frame_chassis_cord_reel_cover",
								stations: [3],
								description: ["Cord reel cover has been installed", "Coiled cord is not visible"],
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 4",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Battery Torque`,
								slug: "CQC-1_battery_torque",
								stations: [4],
								cqc: "CQC-1",
								description: [
									`<u>All</u> battery, shunt, and disconnect terminals torqued to 100 in-lb`,
									`Values recorded per post`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Modem / Gps`,
								slug: "CQC-4_modem_gps",
								stations: [4],
								cqc: "CQC-4",
								description: [
									`Modem powered and connected to provider`,
									`GPS puck installed`,
									`Cerbo reports valid location`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Vrm Readiness`,
								slug: "CQC-5_vrm_readiness",
								stations: [4],
								cqc: "CQC-5",
								description: [
									`<u>All</u> Victron components visible in VRM`,
									`Timestamps correct`,
									`VRM name set`,
									`Transferred to customer account when required`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Battery Monitor &amp; Shunt`,
								slug: "CQC-6_battery_monitor_shunt",
								stations: [4],
								cqc: "CQC-6",
								description: [
									`BMV voltage correct`,
									`Shunt capacity set to 800 Ah`,
									`BMV display shows required fields (Power, SOC, etc.)`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Shore / Solar Controls`,
								slug: "CQC-7_shore_solar_controls",
								stations: [4],
								cqc: "CQC-7",
								description: [
									`Cerbo shore-power state changes correctly`,
									`Solar breaker operation correctly affects PV status/readings`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Bluetooth &amp; Pins`,
								slug: "CQC-8_bluetooth_pins",
								stations: [4],
								cqc: "CQC-8",
								description: [
									`BT disabled on Cerbo/SmartSolar/SmartCharger/BMV`,
									`BT enabled on DC-DCs`,
									`PINs set per current build ticket and recorded`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 5",
				description: null,
				sections: [
					{
						name: `Camera Housing &amp; Provisioning`,
						description: null,
						slug: "camera_housing_provisioning",
						items: [
							{
								name: `Housing &amp; Lock`,
								slug: "CQC-1_housing_lock",
								stations: [5],
								cqc: "CQC-1",
								description: [
									`Masthead housing free of defects`,
									`Door opens/closes smoothly`,
									`751 lock operates`,
									`Seal intact`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Pinout Voltages`,
								slug: "CQC-2_pinout_voltages",
								stations: [5],
								cqc: "CQC-2",
								description: [
									`Masthead pinout: <ul><li>Pin 1 = 48v</li><li>Pin 2 = 20v</li><li>Pin 3 = 12v</li><li>Pins 4-6 = GND</li></ul>`,
									`Verified with test box`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Cable Glands`,
								slug: "CQC-3_cable_glands",
								stations: [5],
								cqc: "CQC-3",
								description: [
									`<u>All</u> glands are black`,
									`Tightened and sealing`,
									`IP67 cords have even external length and proper strain relief`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Beacon &amp; Relays`,
								slug: "CQC-4_beacon_relays",
								stations: [5],
								cqc: "CQC-4",
								description: [
									`Beacon mounted at Position-2`,
									`Relay-1 toggles beacon ON/OFF`,
									`Dependency on 12v "Strobe" breaker verified`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Cameras &amp; Poe`,
								slug: "CQC-5_cameras_poe",
								stations: [5],
								cqc: "CQC-5",
								description: [
									`Two Uniview PTZ + one Axis camera mounted in correct positions`,
									`PoE switch has 48v`,
									`Relevant ports show link/activity lights`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Compute Box`,
								slug: "CQC-6_compute_box",
								stations: [5],
								cqc: "CQC-6",
								description: [
									`Compute Box power LED correct`,
									`Power landed left / Ethernet right`,
									`QR/barcode labels applied and legible`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Generator Securement`,
								slug: "gen_securement",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`Generator is bolted with two (2) bolts and secured in the box`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `LP Monitors`,
								slug: "lp_monitors_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP monitors in the storage box of the unit`,
									`Each LP monitor is to be tested for proper connection and functionality`,
									`Each LP monitor is associated to the unit's CerboGX`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `LP Tanks`,
								slug: "lp_tanks_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP tanks installed properly in the LP Box`,
									`There is an LP warning label on the outside of the box`
								],
								images: null,
								required: true,
							}

						]
					}
				]
			}
			,
			{
				category: "Station 6",
				description: null,
				sections: [
					{
						name: `Solar Mast &amp; Pv Array`,
						description: null,
						slug: "solar_mast_pv_array",
						items: [
							{
								name: `Rack Mechanism`,
								slug: "CQC-1_rack_mechanism",
								stations: [6],
								cqc: "CQC-1",
								description: [
									`Solar rack fully extends/retracts`,
									`Locks engage/release`,
									`3 up/down cycles smooth and without binding`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Panel Securement &amp; Condition`,
								slug: "CQC-2_panel_securement_condition",
								stations: [6],
								cqc: "CQC-2",
								description: [
									`Correct hardware installed and torqued`,
									`Panels free of defects`,
									`PV cords firmly attached and strain-relieved`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Gas Strut`,
								slug: "CQC-3_gas_strut",
								stations: [6],
								cqc: "CQC-3",
								description: [
									`Gas strut installed correctly, hardware secure`,
									`No leaks or visible damage`,
									`Supports motion properly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Terminations &amp; Breaker`,
								slug: "CQC-4_terminations_breaker",
								stations: [6],
								cqc: "CQC-4",
								description: [
									`PV conductors landed on correct charge-controller terminals with correct polarity`,
									`Solar breaker toggles PV input ON/OFF`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Vrm Solar Output`,
								slug: "CQC-5_vrm_solar_output",
								stations: [6],
								cqc: "CQC-5",
								description: [
									`Solar production (PV V/A/W) visible and updating in VRM`,
									`No persistent solar-related faults`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 7",
				description: null,
				sections: [
					{
						name: `Final Qc &amp; Soak`,
						description: null,
						slug: "final_qc_soak",
						items: [
							{
								name: `Connectivity`,
								slug: "CQC-1_connectivity",
								stations: [7],
								cqc: "CQC-1",
								description: [
									`Unit can "phone home"`,
									`Compute Box connects to services`,
									`Power-box modem has active provider connection and stable data`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Visuals`,
								slug: "CQC-2_visuals",
								stations: [7],
								cqc: "CQC-2",
								description: [
									`Final visual inspection passes for Boxes, Masthead, Trailer, Labels, Solar Panels/Rack`,
									`No unresolved defects`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `24-Hour Soak`,
								slug: "unit_readiness_documentation_soaking",
								stations: [7],
								cqc: "CQC-3",
								description: [
									`Outdoor soak started and minimum 24-hour period completed`,
									`No unresolved alarms`,
									`VRM live throughout soak window`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Keys &amp; Locks`,
								slug: "CQC-4_keys_locks",
								stations: [7],
								cqc: "CQC-4",
								description: [
									`Lock box mounted on tongue and set to code 1769`,
									`Winch lock applied with code 1769`,
									`Required keys packed and documented`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Ship Approval`,
								slug: "CQC-5_ship_approval",
								stations: [7],
								cqc: "CQC-5",
								description: [
									`"Flock Approved - Ready to Ship" (or equivalent) recorded`,
									`No open NCRs blocking shipment`,
									`Comfirm in their <a href="https://docs.google.com/spreadsheets/d/1SPSPO9R6aYikiCZWz-fChUP-Y3knW_AKkMNfZujEoU0/edit?usp=sharing" target="_blank">Google Sheet</a>`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `AGS Installation`,
								slug: "ags_installation_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is properly installed and functioning correctly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Check Fuel Lines`,
								slug: "check_fuel_lines_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Conduct a pressure-based test to ensure LP lines work properly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `AGS Functionality Test`,
								slug: "ags_functionality_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is functioning correctly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Generator Run Test (Outdoor)`,
								slug: "gen_run_test_outdoor",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Perform the generator run test with the unit outside`,
									`Generator must be tested in an outdoor environment`
								],
								images: null,
								required: true,
							}

						]
					}
				]
			},
			{
				category: "PDI",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Voltages &amp; Breakers`,
								slug: "CQC-2_voltages_breakers",
								stations: [0],
								cqc: "CQC-2",
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Voltages & Breakers Photo",
										id: "v_breakers_photo",
										overrideComponent: "image",
										description: "Upload a photo showing the voltage readings and breaker configurations",
										required: true,
									},
								]
							}
						]
					},

					{
						name: `Photos`,
						description: null,
						slug: "unit_photos",
						items: [
							{
								name: `Unit Photo Side 1`,
								slug: "unit_photo_side_1",
								stations: [0],
								images: null,
								form: [
									{
										label: "Unit Photo Side 1",
										id: "photo_unit_side_1",
										overrideComponent: "image",
										description: "Upload a photo showing side 1 of the unit",
										required: true,
									}
								]
							}
							,
							{
								name: `Unit Photo Side 2`,
								slug: "unit_photo_side_2",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Side 2",
										id: "photo_unit_side_2",
										overrideComponent: "image",
										description: "Upload a photo showing side 2 of the unit",
										required: true,
									}
								]
							}
							,
							{
								name: `Unit Photo Front`,
								slug: "unit_photo_front",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Front",
										id: "photo_unit_front",
										overrideComponent: "image",
										description: "Upload a photo showing the front of the unit",
										required: true,
									}
								]
							}
							,
							{
								name: `Unit Photo Back`,
								slug: "unit_photo_back",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Back",
										id: "photo_unit_back",
										overrideComponent: "image",
										description: "Upload a photo showing the back of the unit",
								required: true,
									}
								]
							}
							,
							{
								name: `Power Panel Photo`,
								slug: "power_panel_photo",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Power Panel Photo",
										id: "photo_power_panel",
										overrideComponent: "image",
										description: "Upload a photo showing the power panel",
								required: true,
									}
								]
							}
							,
							{
								name: `Camera Housing Photo`,
								slug: "camera_housing_photo",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Camera Housing Photo",
										id: "photo_camera_housing",
										overrideComponent: "image",
										description: "Upload a photo showing the camera housing",
								required: true,
									}
								]
							}
						]
					}
				]
			},

			{
				category: "Logistics",
				description: null,
				sections: [
					{
						name: "Shipping Information",
						description: null,
						items: [
							{
								name: "Shipping Address",
								slug: "logistics_shipping_information_shipping_address",
								stations: [99],
								description: ["Shipping address for the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "logistics_shipping_information_shipping_address_name",
										placeholder: "Name of location",
										description: "Name of where unit is being shipped. If unknown, enter 'N/A'."
									},
									{
										label: "Address",
										type: "text",
										id: "logistics_shipping_information_shipping_address_address",
										placeholder: "Full address",
										description: "Full address of where unit is being shipped. If unknown, enter 'N/A'."
									}
								]
							},
							{
								name: "Carrier",
								slug: "logistics_shipping_information_carrier",
								stations: [99],
								description: ["Carrier responsible for shipping the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Carrier Name",
										type: "text",
										id: "logistics_shipping_information_carrier_carrier_name",
										placeholder: "Enter carrier name",
										description: "Name of the carrier or shipping company responsible for shipping the unit. If unknown, enter 'N/A'."
									}
								]
							}, {
								name: "Shipping Date",
								slug: "logistics_shipping_information_shipping_date",
								stations: [99],
								description: ["Date the unit is shipped"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Shipping Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_shipping_date",
										placeholder: "Select shipping date",
										description: "Date the unit is shipped."
									}, {
										label: "Estimated Arrival Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_estimated_arrival_date",
										placeholder: "Select estimated arrival date",
										description: "Estimated date the unit will arrive at the destination. If unknown, enter same date as Shipping Date."
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Unit Sign-Off",
				description: null,
				sections: [
					{
						name: "Final Sign-Off",
						description: null,
						items: [
							{
								name: "Final Sign-Off",
								slug: "final",
								stations: [100],
								description: ["This unit has been fully inspected, tested, and operated to the best of my ability.", "I approve this unit to be shipped to the customer.", "This unit aligns to the 'Golden Rule' and meets the standards of RVMP quality and care.", "Name and date required."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "final_signoff_user",
										placeholder: "Enter your name",
										description: "You digitally sign this document to approve the unit for shipment."
									}
								]
							}
						]
					}
				]
			}
		]
	}, {
		v5: [
			{
				category: "Overview",
				description: "[V3] Enter information about the unit.",
				sections: [
					{
						name: "Unit Overview",
						description: null,
						items: [
							{
								name: "Unit Identifiers",
								slug: "unit_identifiers",
								stations: [0],
								description: ["Overview of the unit."],
								hideCheckbox: true,
								form: [
									{
										label: "Unit Model",
										type: "text",
										id: "unit_identifiers_unit_model",
										description: "Select the unit model type.",
										overrideComponent: "unitModel",
										required: true,
									},
									{
										label: "Unit VIN",
										type: "tel",
										id: "VIN",
										placeholder: "Enter VIN Number",
										maxLength: 17,
										pattern: "^[A-HJ-NPR-Z0-9]{11,17}$",
										description: "Vehicle Identification Number (11-17 chars).",
										overrideComponent: "vin",
										required: true,

									},
									{
										label: "Unit Identifier (name)",
										type: "text",
										id: "unit_identifiers_unit_identifier_name",
										placeholder: "e.g. Flock Trailer 251234566",
										description: `Human-readable or &quot;speakable&quot; identifier for the unit (asset name or label). <br /> &bull; Name should be 'Flock Trailer ' + 'Two Digit of Year' + 'Unit Number' (last 6 digits of the VIN) + ' ' + 'VIN' + <br />&bull; Example: 'Flock Trailer 2512345656'`,
										required: true,
									},
									{
										label: "Unit Version",
										type: "text",
										id: "unit_identifiers_make_unit_version",
										placeholder: "Enter make/unit version",
										defaultValue: "1.0.1",
										description: "Manufacturer version of hardware/firmware/components.",
										required: true,
									},
									{
										label: "Unit Year",
										type: "number",
										id: "unit_identifiers_unit_year",
										placeholder: "YYYY",
										min: 1900,
										max: 2100,
										step: 1,
										defaultValue: new Date().getFullYear().toString(),
										description: "Model or manufacturing year of the unit (four digits).",
										required: true,
									},
								]
							},
							{
								name: "Generator Details",
								slug: "gen_details",
								stations: [0],
								description: ["Enter details about the generator and related components."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Generator Model &amp; Serial",
										type: "text",
										id: "gen_gen_model",
										placeholder: "Enter model",
										defaultValue: "2800i",
										description: "Select generator model and enter serial number.",
										overrideComponent: "generatorSerial",
										required: true,
									},

									{
										label: "LP Monitor 1",
										type: "text",
										id: "gen_details_lp_monitor_1",
										placeholder: "Enter LP Monitor 1",
										description: "LP tank monitor device 1 connected to CerboGX.",
										defaultValue: "Mopeka",
										required: true,
									},
									{
										label: "LP Monitor 2",
										type: "text",
										id: "gen_details_lp_monitor_2",
										placeholder: "Enter LP Monitor 2",
										description: "LP tank monitor device 2 connected to CerboGX.",
										defaultValue: "Mopeka",
										required: true,
									},
									{
										label: "AGS Model",
										type: "text",
										id: "gen_details_ags_model",
										placeholder: "Enter AGS Model",
										description: "Automatic Generator Start module model.",
										defaultValue: "AGSv1 Module",
										required: true,
									},
									{
										label: "AGS Firmware",
										type: "text",
										id: "gen_details_ags_firmware",
										placeholder: "Enter AGS Firmware version",
										description: "Firmware version of the AGS module.",
										defaultValue: "5",
										required: true,
									}
								]
							},

							{
								name: "Victron Details",
								slug: "victron",
								stations: [0],
								description: ["Details about Victron components.", "Make sure all components are showing in the VRM portal:", "&bull; Go to <b>Advanced</b> &gt; Widgets (top right icon) &gt; Click on each and <b>'Enable All'</b> "],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Victron Power Panel Serial",
										type: "text",
										id: "power_panel_serial",
										placeholder: "25FFP02270000",
										description: "Select the prefix and enter the last 4 digits of the serial number on the Power Panel inside the Power Box.<br /><br /><b>VRM Name Format:</b><br />&bull; Flex Security - [Unit Name] - [Power Panel Serial] - [VIN]<br />&bull; Example: Flex Security - Flock Trailer 592380 - 25FFP02270001 - 1F9F1U410SA592380",
										overrideComponent: "powerPanelSerial",
										required: true,
									},
									{
										label: "VRM Link",
										type: "url",
										id: "victron_vrm_link",
										placeholder: "https://vrm.victronenergy.com/...",
										description: "Direct URL to the unit in Victron VRM."
									},
									{
										label: "'Victron Cerbo GX' Serial Number",
										type: "text",
										id: "victron_victron_cerbo_gx_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Cerbo GX."
									},
									{
										label: "'SmartSolar Charge Controller MPPT 150A' Serial Number",
										type: "text",
										id: "victron_charge_controller_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartSolar Charge Controller."
									},
									{
										label: "'Orion-Tr 12v|24v - 10A' Serial Number",
										type: "text",
										id: "victron_orion_tr_12v_24v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr 12v|24v."
									},
									{
										label: "'Orion-Tr Smart 12v|48v - 8A' Serial Number",
										type: "text",
										id: "victron_orion_tr_smart_12v_48v_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Orion-Tr Smart 12v|48v."
									},
									{
										label: "'SmartCharger 12v|50A'. Serial Number",
										type: "text",
										id: "victron_smartcharger_12v_50a_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the SmartCharger 12v|50A."
									},
									{
										label: "Victron Battery Monitor Serial Number",
										type: "text",
										id: "victron_victron_battery_monitor_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number printed on the Victron Battery Monitor."
									}
								]
							},

							{
								name: "Modem (Power Box)",
								slug: "modem_power_box",
								stations: [0],
								description: ["The cellular modem located in the Power Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Modem (Power Box) Make",
										type: "text",
										id: "modem_power_box_modem_power_box_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the Power Box modem.",
										defaultValue: "Sierra Wireless"
									},
									{
										label: "Modem (Power Box) Model",
										type: "text",
										id: "modem_power_box_modem_power_box_model",
										placeholder: "Enter model",
										description: "Model name or number of the Power Box modem.",
										defaultValue: "6001124"
									},
									{
										label: "Modem (Power Box) Serial Number",
										type: "text",
										id: "modem_power_box_modem_power_box_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the Power Box modem.",
										defaultValue: "N/A"
									}
								]
							},

							{
								name: "Compute Box",
								slug: "compute_box",
								stations: [0],
								description: ["Enter details about the Compute Box."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Compute Box Make",
										type: "text",
										id: "compute_box_compute_box_make",
										placeholder: "Enter Maker",
										description: "Maker of the Compute Box",
										defaultValue: "Flock",
										required: true,
									},
									{
										label: "Compute Box Model",
										type: "text",
										id: "compute_box_compute_box_model",
										placeholder: "Enter Model",
										description: "Model of the Compute Box",
										defaultValue: "705-00010",
										required: true,
									},
									{
										label: "Compute Box Version",
										type: "text",
										id: "compute_box_compute_box_version",
										placeholder: "Enter Version",
										description: "Version assigned to the Compute Box.",
										defaultValue: "1.1.0",
										required: true,
									},
									{
										label: "Date Created of Compute Box",
										type: "text",
										id: "compute_box_compute_box_date_created",
										placeholder: "Enter Date Created",
										description: "Date when the Compute Box was created.",
										defaultValue: (new Date()).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
									},
									{
										label: "Compute Box Serial Number",
										type: "text",
										id: "compute_box_compute_box_serial_number",
										placeholder: "Enter serial number",
										description: "Serial number assigned to the Compute Box.",
										required: true,
									}
								]
							},

							{
								name: "PoE Switch",
								slug: "poe_switch",
								stations: [0],
								description: ["Manufacturer/brand and serial for the PoE switch."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "PoE Switch Make",
										type: "text",
										id: "poe_switch_poe_switch_make",
										placeholder: "Enter make",
										description: "Manufacturer/brand of the PoE switch.",
										defaultValue: "Linovision",
										required: true,
									},
									{
										label: "PoE Switch Model",
										type: "text",
										id: "poe_switch_poe_switch_model",
										placeholder: "Enter model",
										description: "Model of the PoE switch.",
										defaultValue: "8-Port (POE-SW508G2)",
										required: true,
									},
									{
										label: "PoE Switch Serial Number",
										type: "text",
										id: "poe_switch_poe_switch_serial_number",
										placeholder: "Enter serial number",
										description: "Manufacturer serial number of the PoE switch.",
										defaultValue: "N/A"
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Station 1",
				description: null,
				sections: [
					{
						name: `Frame &amp; Chassis`,
						description: null,
						slug: "frame_chassis",
						items: [
							{
								name: `Wheel Lugs Torque`,
								slug: "CQC-1_wheel_lugs_torque",
								stations: [1],
								cqc: "CQC-1",
								description: [
									`<u>All</u> wheel lugs torqued to <b>80 ft-lb</b>`,
									`NOTE: Values recorded <b><u>per</u> wheel</b>`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Stabilizing Jacks`,
								slug: "CQC-2_stabilizing_jacks",
								stations: [1],
								cqc: "CQC-2",
								description: [
									`4 jacks installed`,
									`3 full up/down cycles each`,
									`No binding or abnormal behavior`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Locking Pins`,
								slug: "CQC-3_locking_pins",
								stations: [1],
								cqc: "CQC-3",
								description: [
									`Pins extend/retract and lock`,
									`3 total cycles`,
									`No deformation or sticking`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Tongue Jack`,
								slug: "CQC-4_tongue_jack",
								stations: [1],
								cqc: "CQC-4",
								description: [
									`Tongue jack operates up/down, swivels, and locks`,
									`No visible defects`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Strobes`,
								slug: "CQC-5_strobes",
								stations: [1],
								cqc: "CQC-5",
								description: [
									`2 strobes installed and operational`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Covers, Tread, Chains, Vin`,
								slug: "CQC-7_covers_tread_chains_vin",
								stations: [1],
								cqc: "CQC-7",
								description: [
									`Step-tread secure`,
									`Chains secure`,
									`VIN tag present at specified location`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 2",
				description: null,
				sections: [
					{
						name: `Box Striping / Drilling / Branding`,
						description: null,
						slug: "box_striping_drilling_branding",
						items: [
							{
								name: `Graphics Quality`,
								slug: "CQC-1_graphics_quality",
								stations: [2],
								cqc: "CQC-1",
								description: [
									`<u>All</u> boxes branded`,
									`Stripes/decals aligned`,
									`No bubbles or misprints`,
									`Unit Label on Power Box`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Locks &amp; Keys`,
								slug: "CQC-2_locks_keys",
								stations: [2],
								cqc: "CQC-2",
								description: [
									`Storage boxes lock/unlock with specified key families (CH545, T001, 751)`,
									`2 keys per lock family provided`,
									`<ul><li>Power/Storage Box: CH545 or T001</li><li>Generator Box: 751</li><li>Masthead: 751</li></ul>`,
									`If keys not provided, note in Details section`,
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Struts`,
								slug: "CQC-3_struts",
								stations: [2],
								cqc: "CQC-3",
								description: [
									`Lids open/close smoothly`,
									`Struts hold lids`,
									`No excessive play`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Box Condition`,
								slug: "CQC-4_box_condition",
								stations: [2],
								cqc: "CQC-4",
								description: [
									`Boxes free of scratches/dents beyond spec`,
									`Vents/holes only as specified`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Warning Labels &amp; Placement`,
								slug: "CQC-5_warning_labels_placement",
								stations: [2],
								cqc: "CQC-5",
								description: [
									`“Call 911” (2/unit), Cord Warning, Level Warnings, Surveillance Notice, Lithium Battery Warning applied in specified locations and legible`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 3",
				description: null,
				sections: [
					{
						name: `Camera Mast &amp; Storage Boxes`,
						description: null,
						slug: "camera_mast_storage_boxes",
						items: [
							{
								name: `Mast Cycling`,
								slug: "CQC-1_mast_cycling",
								stations: [3],
								cqc: "CQC-1",
								description: [
									`Mast extends/retracts smoothly for 3 full cycles`,
									`No catching or misalignment`
								],
								images: null,
								required: true,
							},
							,
							{
								name: `Winch Securement`,
								slug: "CQC-2_winch_securement",
								stations: [3],
								cqc: "CQC-2",
								description: [
									`Winch welds/bolts intact`,
									`No deformation or looseness under load. Holes Drilled for Lockbox`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Cable &amp; Tension`,
								slug: "CQC-3_cable_tension",
								stations: [3],
								cqc: "CQC-3",
								description: [
									`Cable free of kinks/frays`,
									`Correctly routed`,
									`Tension set to spec`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Lubrication`,
								slug: "CQC-4_lubrication",
								stations: [3],
								cqc: "CQC-4",
								description: [
									`Wormwheel and internal pucks visibly lubricated at all required points`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Mast Finish &amp; Graphics`,
								slug: "CQC-5_mast_finish_graphics",
								stations: [3],
								cqc: "CQC-5",
								description: [
									`Mast surfaces free of major scratches/dents`,
									`Graphics correct and undamaged`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Storage Boxes`,
								slug: "CQC-6_storage_boxes",
								stations: [3],
								cqc: "CQC-6",
								description: [
									`Storage boxes installed`,
									`Graphics/locks/struts meet ST-02 CQC requirements`
								],
								images: null,
								required: true,
							},
							{
								name: "Cord reel cover",
								slug: "frame_chassis_cord_reel_cover",
								stations: [3],
								description: ["Cord reel cover has been installed", "Coiled cord is not visible"],
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 4",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Battery Torque`,
								slug: "CQC-1_battery_torque",
								stations: [4],
								cqc: "CQC-1",
								description: [
									`<u>All</u> battery, shunt, and disconnect terminals torqued to 100 in-lb`,
									`Values recorded per post`
								],
								images: null,
								required: true,
							},



							{
								name: `Torque Mast Cable Wires`,
								slug: "Torque_Mast_Cable_Wires",
								stations: [4],
								cqc: null,
								description: [
									`Torque mast cable wires at breakers to 20 in-lb`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Modem / Gps`,
								slug: "CQC-4_modem_gps",
								stations: [4],
								cqc: "CQC-4",
								description: [
									`Modem powered and connected to provider`,
									`GPS puck installed`,
									`Cerbo reports valid location`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Vrm Readiness`,
								slug: "CQC-5_vrm_readiness",
								stations: [4],
								cqc: "CQC-5",
								description: [
									`<u>All</u> Victron components visible in VRM`,
									`Timestamps correct`,
									`VRM name set`,
									`Transferred to customer account when required`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Battery Monitor &amp; Shunt`,
								slug: "CQC-6_battery_monitor_shunt",
								stations: [4],
								cqc: "CQC-6",
								description: [
									`BMV voltage correct`,
									`Shunt capacity set to 800 Ah`,
									`BMV display shows required fields (Power, SOC, etc.)`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Shore / Solar Controls`,
								slug: "CQC-7_shore_solar_controls",
								stations: [4],
								cqc: "CQC-7",
								description: [
									`Cerbo shore-power state changes correctly`,
									`Solar breaker operation correctly affects PV status/readings`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Bluetooth &amp; Pins`,
								slug: "CQC-8_bluetooth_pins",
								stations: [4],
								cqc: "CQC-8",
								description: [
									`BT disabled on Cerbo/SmartSolar/SmartCharger/BMV`,
									`BT enabled on DC-DCs`,
									`PINs set per current build ticket and recorded`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 5",
				description: null,
				sections: [
					{
						name: `Camera Housing &amp; Provisioning`,
						description: null,
						slug: "camera_housing_provisioning",
						items: [
							{
								name: `Housing &amp; Lock`,
								slug: "CQC-1_housing_lock",
								stations: [5],
								cqc: "CQC-1",
								description: [
									`Masthead housing free of defects`,
									`Door opens/closes smoothly`,
									`751 lock operates`,
									`Seal intact`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Pinout Voltages`,
								slug: "CQC-2_pinout_voltages",
								stations: [5],
								cqc: "CQC-2",
								description: [
									`Masthead pinout: <ul><li>Pin 1 = 48v</li><li>Pin 2 = 20v</li><li>Pin 3 = 12v</li><li>Pins 4-6 = GND</li></ul>`,
									`Verified with test box`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Cable Glands`,
								slug: "CQC-3_cable_glands",
								stations: [5],
								cqc: "CQC-3",
								description: [
									`<u>All</u> glands are black`,
									`Tightened and sealing`,
									`IP67 cords have even external length and proper strain relief`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Beacon &amp; Relays`,
								slug: "CQC-4_beacon_relays",
								stations: [5],
								cqc: "CQC-4",
								description: [
									`Beacon mounted at Position-2`,
									`Relay-1 toggles beacon ON/OFF`,
									`Dependency on 12v "Strobe" breaker verified`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Cameras &amp; Poe`,
								slug: "CQC-5_cameras_poe",
								stations: [5],
								cqc: "CQC-5",
								description: [
									`Two Uniview PTZ + one Axis camera mounted in correct positions`,
									`PoE switch has 48v`,
									`Relevant ports show link/activity lights`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Compute Box`,
								slug: "CQC-6_compute_box",
								stations: [5],
								cqc: "CQC-6",
								description: [
									`Compute Box power LED correct`,
									`Power landed left / Ethernet right`,
									`QR/barcode labels applied and legible`
								],
								images: null,
								required: true,
							},


							{
								name: `Loctite Camera Mount Threads`,
								slug: "Loctite_Camera_Mount_Threads",
								stations: [5],
								cqc: null,
								description: [
									`Loctite must be applied to all camera mount related threads`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Generator Securement`,
								slug: "gen_securement",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`Generator is bolted with two (2) bolts and secured in the box`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `LP Monitors`,
								slug: "lp_monitors_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP monitors in the storage box of the unit`,
									`Each LP monitor is to be tested for proper connection and functionality`,
									`Each LP monitor is associated to the unit's CerboGX`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `LP Tanks`,
								slug: "lp_tanks_qc",
								stations: [4],
								cqc: 'cqc-gen',
								description: [
									`There are two (2) LP tanks installed properly in the LP Box`,
									`There is an LP warning label on the outside of the box`
								],
								images: null,
								required: true,
							}

						]
					}
				]
			}
			,
			{
				category: "Station 6",
				description: null,
				sections: [
					{
						name: `Solar Mast &amp; Pv Array`,
						description: null,
						slug: "solar_mast_pv_array",
						items: [

							{
								name: `Rack Mechanism`,
								slug: "CQC-1_rack_mechanism",
								stations: [6],
								cqc: "CQC-1",
								description: [
									`Solar rack fully extends/retracts`,
									`Locks engage/release`,
									`3 up/down cycles smooth and without binding`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Panel Securement &amp; Condition`,
								slug: "CQC-2_panel_securement_condition",
								stations: [6],
								cqc: "CQC-2",
								description: [
									`Correct hardware installed and torqued`,
									`Panels free of defects`,
									`PV cords firmly attached and strain-relieved`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Gas Strut`,
								slug: "CQC-3_gas_strut",
								stations: [6],
								cqc: "CQC-3",
								description: [
									`Gas strut installed correctly, hardware secure`,
									`No leaks or visible damage`,
									`Supports motion properly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Terminations &amp; Breaker`,
								slug: "CQC-4_terminations_breaker",
								stations: [6],
								cqc: "CQC-4",
								description: [
									`PV conductors landed on correct charge-controller terminals with correct polarity`,
									`Solar breaker toggles PV input ON/OFF`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Vrm Solar Output`,
								slug: "CQC-5_vrm_solar_output",
								stations: [6],
								cqc: "CQC-5",
								description: [
									`Solar production (PV V/A/W) visible and updating in VRM`,
									`No persistent solar-related faults`
								],
								images: null,
								required: true,
							}
						]
					}
				]
			}
			,
			{
				category: "Station 7",
				description: null,
				sections: [
					{
						name: `Final Qc &amp; Soak`,
						description: null,
						slug: "final_qc_soak",
						items: [
							{
								name: `Connectivity`,
								slug: "CQC-1_connectivity",
								stations: [7],
								cqc: "CQC-1",
								description: [
									`Unit can "phone home"`,
									`Compute Box connects to services`,
									`Power-box modem has active provider connection and stable data`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Visuals`,
								slug: "CQC-2_visuals",
								stations: [7],
								cqc: "CQC-2",
								description: [
									`Final visual inspection passes for Boxes, Masthead, Trailer, Labels, Solar Panels/Rack`,
									`No unresolved defects`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `24-Hour Soak`,
								slug: "unit_readiness_documentation_soaking",
								stations: [7],
								cqc: "CQC-3",
								description: [
									`Outdoor soak started and minimum 24-hour period completed`,
									`No unresolved alarms`,
									`VRM live throughout soak window`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Keys &amp; Locks`,
								slug: "CQC-4_keys_locks",
								stations: [7],
								cqc: "CQC-4",
								description: [
									`Set to code to the "last 4 digits of the VIN"`,
									`Attach lock box to the winch`,
									`Required keys packed and documented`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Ship Approval`,
								slug: "CQC-5_ship_approval",
								stations: [7],
								cqc: "CQC-5",
								description: [
									`"Flock Approved - Ready to Ship" (or equivalent) recorded`,
									`No open NCRs blocking shipment`,
									`Comfirm in their <a href="https://docs.google.com/spreadsheets/d/1SPSPO9R6aYikiCZWz-fChUP-Y3knW_AKkMNfZujEoU0/edit?usp=sharing" target="_blank">Google Sheet</a>`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `AGS Installation`,
								slug: "ags_installation_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is properly installed and functioning correctly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Check Fuel Lines`,
								slug: "check_fuel_lines_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Conduct a pressure-based test to ensure LP lines work properly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `AGS Functionality Test`,
								slug: "ags_functionality_qc",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Test that AGS is functioning correctly`
								],
								images: null,
								required: true,
							}
							,
							{
								name: `Generator Run Test (Outdoor)`,
								slug: "gen_run_test_outdoor",
								stations: [7],
								cqc: 'cqc-gen',
								description: [
									`Perform the generator run test with the unit outside`,
									`Generator must be tested in an outdoor environment`
								],
								images: null,
								required: true,
							}

						]
					}
				]
			},
			{
				category: "PDI",
				description: null,
				sections: [
					{
						name: `Victron Power &amp; Battery`,
						description: null,
						slug: "victron_power_battery",
						items: [
							{
								name: `Voltages &amp; Breakers`,
								slug: "CQC-2_voltages_breakers",
								stations: [0],
								cqc: "CQC-2",
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Voltages & Breakers Photo",
										id: "v_breakers_photo",
										overrideComponent: "image",
										description: "Upload a photo showing the voltage readings and breaker configurations",
										required: true,
									},
								]
							}
						]
					},

					{
						name: `Photos`,
						description: null,
						slug: "unit_photos",
						items: [
							{
								name: `Unit Photo Side 1`,
								slug: "unit_photo_side_1",
								stations: [0],
								images: null,
								form: [
									{
										label: "Unit Photo Side 1",
										id: "photo_unit_side_1",
										overrideComponent: "image",
										description: "Upload a photo showing side 1 of the unit",
										required: true,
									}
								]
							}
							,
							{
								name: `Unit Photo Side 2`,
								slug: "unit_photo_side_2",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Side 2",
										id: "photo_unit_side_2",
										overrideComponent: "image",
										description: "Upload a photo showing side 2 of the unit",
										required: true,
									}
								]
							}
							,
							{
								name: `Unit Photo Front`,
								slug: "unit_photo_front",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Front",
										id: "photo_unit_front",
										overrideComponent: "image",
										description: "Upload a photo showing the front of the unit",
										required: true,
									}
								]
							}
							,
							{
								name: `Unit Photo Back`,
								slug: "unit_photo_back",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Unit Photo Back",
										id: "photo_unit_back",
										overrideComponent: "image",
										description: "Upload a photo showing the back of the unit",
								required: true,
									}
								]
							}
							,
							{
								name: `Power Panel Photo`,
								slug: "power_panel_photo",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Power Panel Photo",
										id: "photo_power_panel",
										overrideComponent: "image",
										description: "Upload a photo showing the power panel",
								required: true,
									}
								]
							}
							,
							{
								name: `Camera Housing Photo`,
								slug: "camera_housing_photo",
								stations: [0],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Camera Housing Photo",
										id: "photo_camera_housing",
										overrideComponent: "image",
										description: "Upload a photo showing the camera housing",
								required: true,
									}
								]
							}
						]
					}
				]
			},

			{
				category: "Logistics",
				description: null,
				sections: [
					{
						name: "Shipping Information",
						description: null,
						items: [
							{
								name: "Shipping Address",
								slug: "logistics_shipping_information_shipping_address",
								stations: [99],
								description: ["Shipping address for the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "logistics_shipping_information_shipping_address_name",
										placeholder: "Name of location",
										description: "Name of where unit is being shipped. If unknown, enter 'N/A'."
									},
									{
										label: "Address",
										type: "text",
										id: "logistics_shipping_information_shipping_address_address",
										placeholder: "Full address",
										description: "Full address of where unit is being shipped. If unknown, enter 'N/A'."
									}
								]
							},
							{
								name: "Carrier",
								slug: "logistics_shipping_information_carrier",
								stations: [99],
								description: ["Carrier responsible for shipping the unit"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Carrier Name",
										type: "text",
										id: "logistics_shipping_information_carrier_carrier_name",
										placeholder: "Enter carrier name",
										description: "Name of the carrier or shipping company responsible for shipping the unit. If unknown, enter 'N/A'."
									}
								]
							}, {
								name: "Shipping Date",
								slug: "logistics_shipping_information_shipping_date",
								stations: [99],
								description: ["Date the unit is shipped"],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Shipping Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_shipping_date",
										placeholder: "Select shipping date",
										description: "Date the unit is shipped."
									}, {
										label: "Estimated Arrival Date",
										type: "date",
										id: "logistics_shipping_information_shipping_date_estimated_arrival_date",
										placeholder: "Select estimated arrival date",
										description: "Estimated date the unit will arrive at the destination. If unknown, enter same date as Shipping Date."
									}
								]
							}
						]
					}
				]
			},
			{
				category: "Unit Sign-Off",
				description: null,
				sections: [
					{
						name: "Final Sign-Off",
						description: null,
						items: [
							{
								name: "Final Sign-Off",
								slug: "final",
								stations: [100],
								description: ["This unit has been fully inspected, tested, and operated to the best of my ability.", "I approve this unit to be shipped to the customer.", "This unit aligns to the 'Golden Rule' and meets the standards of RVMP quality and care.", "Name and date required."],
								images: null,
								hideCheckbox: true,
								form: [
									{
										label: "Name",
										type: "text",
										id: "final_signoff_user",
										placeholder: "Enter your name",
										description: "You digitally sign this document to approve the unit for shipment."
									}
								]
							}
						]
					}
				]
			}
		]
	}]
};
